export const namespaceToPackageMappings = [
    {
        identifier: 'Symfony\\Polyfill\\Mbstring\\',
        package: 'symfony/polyfill-mbstring',
    },
    {
        identifier: 'Psr\\Log\\',
        package: 'psr/log',
    },
    {
        identifier: 'Symfony\\Polyfill\\Ctype\\',
        package: 'symfony/polyfill-ctype',
    },
    {
        identifier: 'Psr\\Container\\',
        package: 'psr/container',
    },
    {
        identifier: 'Guzzle',
        package: 'guzzlehttp/guzzle',
    },
    {
        identifier: 'Doctrine\\Instantiator\\',
        package: 'doctrine/instantiator',
    },
    {
        identifier: 'Psr\\Http\\Message\\',
        package: 'psr/http-message',
    },
    {
        identifier: 'GuzzleHttp\\Psr7\\',
        package: 'guzzlehttp/psr7',
    },
    {
        identifier: 'Webmozart\\Assert\\',
        package: 'webmozart/assert',
    },
    {
        identifier: 'Doctrine\\Common\\Lexer\\',
        package: 'doctrine/lexer',
    },
    {
        identifier: 'Doctrine\\Common\\Inflector\\',
        package: 'doctrine/inflector',
    },
    {
        identifier: 'Symfony\\Component\\Debug\\',
        package: 'symfony/debug',
    },
    {
        identifier: 'GuzzleHttp\\Promise\\',
        package: 'guzzlehttp/promises',
    },
    {
        identifier: 'phpDocumentor/Reflection',
        package: 'phpdocumentor/reflection-docblock',
    },
    {
        identifier: 'phpDocumentor\\Reflection\\',
        package: 'phpdocumentor/type-resolver',
    },
    {
        identifier: 'phpDocumentor\\Reflection\\',
        package: 'phpdocumentor/reflection-common',
    },
    {
        identifier: 'Prophecy',
        package: 'phpspec/prophecy',
    },
    {
        identifier: 'Symfony\\Polyfill\\Php72\\',
        package: 'symfony/polyfill-php72',
    },
    {
        identifier: 'DeepCopy',
        package: 'myclabs/deep-copy',
    },
    {
        identifier: 'PHPParser',
        package: 'nikic/php-parser',
    },
    {
        identifier: 'Symfony\\Component\\VarDumper\\',
        package: 'symfony/var-dumper',
    },
    {
        identifier: 'Psr\\SimpleCache\\',
        package: 'psr/simple-cache',
    },
    {
        identifier: 'Doctrine\\Common\\Cache\\',
        package: 'doctrine/cache',
    },
    {
        identifier: 'Symfony\\Contracts\\Service\\',
        package: 'symfony/service-contracts',
    },
    {
        identifier: 'Symfony\\Polyfill\\Php73\\',
        package: 'symfony/polyfill-php73',
    },
    {
        identifier: 'Symfony\\Polyfill\\Intl\\Idn\\',
        package: 'symfony/polyfill-intl-idn',
    },
    {
        identifier: 'Rhumsaa\\Uuid',
        package: 'ramsey/uuid',
    },
    {
        identifier: 'Symfony\\Component\\Filesystem',
        package: 'symfony/filesystem',
    },
    {
        identifier: 'egulias\\',
        package: 'egulias/email-validator',
    },
    {
        identifier: 'Carbon',
        package: 'nesbot/carbon',
    },
    {
        identifier: 'Doctrine\\Common\\Annotations\\',
        package: 'doctrine/annotations',
    },
    {
        identifier: 'Flysystem',
        package: 'league/flysystem',
    },
    {
        identifier: 'Doctrine\\DBAL',
        package: 'doctrine/dbal',
    },
    {
        identifier: 'Symfony\\Component\\Mime\\',
        package: 'symfony/mime',
    },
    {
        identifier: 'Symfony\\Contracts\\EventDispatcher\\',
        package: 'symfony/event-dispatcher-contracts',
    },
    {
        identifier: 'Dotenv',
        package: 'vlucas/phpdotenv',
    },
    {
        identifier: 'Symfony\\Contracts\\Translation\\',
        package: 'symfony/translation-contracts',
    },
    {
        identifier: 'Faker',
        package: 'fzaninotto/faker',
    },
    {
        identifier: 'Symfony\\Polyfill\\Iconv\\',
        package: 'symfony/polyfill-iconv',
    },
    {
        identifier: 'Psr\\Cache\\',
        package: 'psr/cache',
    },
    {
        identifier: 'Doctrine\\Common\\',
        package: 'doctrine/event-manager',
    },
    {
        identifier: 'Psy\\',
        package: 'psy/psysh',
    },
    {
        identifier: 'JakubOnderka\\PhpConsoleColor',
        package: 'jakub-onderka/php-console-color',
    },
    {
        identifier: 'JakubOnderka\\PhpConsoleHighlighter',
        package: 'jakub-onderka/php-console-highlighter',
    },
    {
        identifier: 'PhpOption\\',
        package: 'phpoption/phpoption',
    },
    {
        identifier: 'Doctrine\\Common\\Collections\\',
        package: 'doctrine/collections',
    },
    {
        identifier: 'XdgBaseDir\\',
        package: 'dnoegel/php-xdg-base-dir',
    },
    {
        identifier: 'Aws',
        package: 'aws/aws-sdk-php',
    },
    {
        identifier: 'Illuminate',
        package: 'laravel/framework',
    },
    {
        identifier: 'Mockery',
        package: 'mockery/mockery',
    },
    {
        identifier: 'Parsedown',
        package: 'erusev/parsedown',
    },
    {
        identifier: 'Symfony\\Component\\OptionsResolver',
        package: 'symfony/options-resolver',
    },
    {
        identifier: 'Symfony\\Polyfill\\Php70\\',
        package: 'symfony/polyfill-php70',
    },
    {
        identifier: 'Hamcrest',
        package: 'hamcrest/hamcrest-php',
    },
    {
        identifier: 'PackageVersions\\',
        package: 'ocramius/package-versions',
    },
    {
        identifier: 'Composer\\CaBundle\\',
        package: 'composer/ca-bundle',
    },
    {
        identifier: 'JmesPath\\',
        package: 'mtdowling/jmespath.php',
    },
    {
        identifier: 'Symfony\\Polyfill\\Util\\',
        package: 'symfony/polyfill-util',
    },
    {
        identifier: 'Symfony\\Polyfill\\Php56\\',
        package: 'symfony/polyfill-php56',
    },
    {
        identifier: 'Composer\\Semver\\',
        package: 'composer/semver',
    },
    {
        identifier: 'Opis\\Closure\\',
        package: 'opis/closure',
    },
    {
        identifier: 'Crypt',
        package: 'phpseclib/phpseclib',
    },
    {
        identifier: 'Laravel\\Tinker\\',
        package: 'laravel/tinker',
    },
    {
        identifier: 'Composer\\XdebugHandler\\',
        package: 'composer/xdebug-handler',
    },
    {
        identifier: 'Zend\\Diactoros\\',
        package: 'zendframework/zend-diactoros',
    },
    {
        identifier: 'Cron',
        package: 'dragonmantank/cron-expression',
    },
    {
        identifier: 'Fideloper\\Proxy',
        package: 'fideloper/proxy',
    },
    {
        identifier: 'Damnit',
        package: 'filp/whoops',
    },
    {
        identifier: 'Zend\\EventManager\\',
        package: 'zendframework/zend-eventmanager',
    },
    {
        identifier: 'Zend\\Code\\',
        package: 'zendframework/zend-code',
    },
    {
        identifier: 'Predis',
        package: 'predis/predis',
    },
    {
        identifier: 'Doctrine\\Common\\',
        package: 'doctrine/persistence',
    },
    {
        identifier: 'JsonSchema',
        package: 'justinrainbow/json-schema',
    },
    {
        identifier: 'Doctrine\\ORM',
        package: 'doctrine/orm',
    },
    {
        identifier: 'Symfony\\Component\\Stopwatch\\',
        package: 'symfony/stopwatch',
    },
    {
        identifier: 'Symfony\\Component\\ErrorHandler\\',
        package: 'symfony/error-handler',
    },
    {
        identifier: 'Symfony\\Component\\BrowserKit',
        package: 'symfony/browser-kit',
    },
    {
        identifier: 'Doctrine\\Common\\',
        package: 'doctrine/reflection',
    },
    {
        identifier: 'Lcobucci\\JWT\\',
        package: 'lcobucci/jwt',
    },
    {
        identifier: 'Symfony\\Component\\Cache\\',
        package: 'symfony/cache',
    },
    {
        identifier: 'Symfony\\Component\\PropertyAccess\\',
        package: 'symfony/property-access',
    },
    {
        identifier: 'Interop\\Container\\',
        package: 'container-interop/container-interop',
    },
    {
        identifier: 'React\\Promise',
        package: 'react/promise',
    },
    {
        identifier: 'Doctrine\\Bundle\\DoctrineBundle',
        package: 'doctrine/doctrine-bundle',
    },
    {
        identifier: 'Http\\Adapter\\',
        package: 'php-http/httplug',
    },
    {
        identifier: 'Http\\Promise\\',
        package: 'php-http/promise',
    },
    {
        identifier: 'Symfony\\Bundle\\MonologBundle',
        package: 'symfony/monolog-bundle',
    },
    {
        identifier: 'ProxyManager\\',
        package: 'ocramius/proxy-manager',
    },
    {
        identifier: 'Symfony\\Component\\Inflector\\',
        package: 'symfony/inflector',
    },
    {
        identifier: 'Sensio\\Bundle\\FrameworkExtraBundle',
        package: 'sensio/framework-extra-bundle',
    },
    {
        identifier: 'Symfony\\Component\\VarExporter\\',
        package: 'symfony/var-exporter',
    },
    {
        identifier: 'Seld\\JsonLint',
        package: 'seld/jsonlint',
    },
    {
        identifier: 'Psr\\Http\\Message\\',
        package: 'psr/http-factory',
    },
    {
        identifier: 'Http\\Message\\',
        package: 'php-http/message-factory',
    },
    {
        identifier: 'Doctrine\\Bundle\\DoctrineCacheBundle',
        package: 'doctrine/doctrine-cache-bundle',
    },
    {
        identifier: 'Symfony\\Bridge\\PhpUnit\\',
        package: 'symfony/phpunit-bridge',
    },
    {
        identifier: 'Google\\Auth\\',
        package: 'google/auth',
    },
    {
        identifier: 'NunoMaduro\\Collision\\',
        package: 'nunomaduro/collision',
    },
    {
        identifier: 'GuzzleHttp\\Stream\\',
        package: 'guzzlehttp/streams',
    },
    {
        identifier: 'Doctrine\\DBAL\\Migrations',
        package: 'doctrine/migrations',
    },
    {
        identifier: 'Http\\Message\\',
        package: 'php-http/message',
    },
    {
        identifier: 'GuzzleHttp\\Ring\\',
        package: 'guzzlehttp/ringphp',
    },
    {
        identifier: 'Clue\\StreamFilter\\',
        package: 'clue/stream-filter',
    },
    {
        identifier: 'Composer',
        package: 'composer/composer',
    },
    {
        identifier: 'Http\\Discovery\\',
        package: 'php-http/discovery',
    },
    {
        identifier: 'Zend\\Stdlib\\',
        package: 'zendframework/zend-stdlib',
    },
    {
        identifier: 'Jean85\\',
        package: 'jean85/pretty-package-versions',
    },
    {
        identifier: 'PhpOffice\\PhpSpreadsheet\\',
        package: 'phpoffice/phpspreadsheet',
    },
    {
        identifier: 'Composer\\Spdx\\',
        package: 'composer/spdx-licenses',
    },
    {
        identifier: 'Behat\\Transliterator',
        package: 'behat/transliterator',
    },
    {
        identifier: 'Elasticsearch',
        package: 'elasticsearch/elasticsearch',
    },
    {
        identifier: 'Seld\\PharUtils\\',
        package: 'seld/phar-utils',
    },
    {
        identifier: 'Symfony\\Bundle\\FrameworkBundle',
        package: 'symfony/framework-bundle',
    },
    {
        identifier: 'Symfony\\Contracts\\Cache\\',
        package: 'symfony/cache-contracts',
    },
    {
        identifier: 'Behat\\Gherkin',
        package: 'behat/gherkin',
    },
    {
        identifier: 'Symfony\\Component\\Dotenv\\',
        package: 'symfony/dotenv',
    },
    {
        identifier: 'Symfony\\Bridge\\PsrHttpMessage\\',
        package: 'symfony/psr-http-message-bridge',
    },
    {
        identifier: 'Doctrine\\Bundle\\DoctrineMigrationsBundle',
        package: 'doctrine/doctrine-migrations-bundle',
    },
    {
        identifier: 'Symfony\\Bundle\\SwiftmailerBundle',
        package: 'symfony/swiftmailer-bundle',
    },
    {
        identifier: 'Metadata\\',
        package: 'jms/metadata',
    },
    {
        identifier: 'Symfony\\CS',
        package: 'friendsofphp/php-cs-fixer',
    },
    {
        identifier: 'Http\\Client\\Common\\',
        package: 'php-http/client-common',
    },
    {
        identifier: 'Symfony\\Component\\Intl\\',
        package: 'symfony/intl',
    },
    {
        identifier: 'League\\Flysystem\\AwsS3v3\\',
        package: 'league/flysystem-aws-s3-v3',
    },
    {
        identifier: 'Symfony\\Component\\ExpressionLanguage\\',
        package: 'symfony/expression-language',
    },
    {
        identifier: 'Complex\\',
        package: 'markbaker/complex',
    },
    {
        identifier: 'Intervention\\Image',
        package: 'intervention/image',
    },
    {
        identifier: 'Raven_',
        package: 'sentry/sentry',
    },
    {
        identifier: 'Complex\\',
        package: 'markbaker/matrix',
    },
    {
        identifier: 'Symfony\\Flex\\',
        package: 'symfony/flex',
    },
    {
        identifier: 'Zend\\Escaper\\',
        package: 'zendframework/zend-escaper',
    },
    {
        identifier: 'Symfony\\Bundle\\TwigBundle',
        package: 'symfony/twig-bundle',
    },
    {
        identifier: 'Psr\\Link\\',
        package: 'psr/link',
    },
    {
        identifier: 'Google',
        package: 'google/apiclient',
    },
    {
        identifier: 'JMS\\Serializer',
        package: 'jms/serializer',
    },
    {
        identifier: 'Symfony\\Bridge\\Doctrine',
        package: 'symfony/doctrine-bridge',
    },
    {
        identifier: 'SensioLabs\\Security',
        package: 'sensiolabs/security-checker',
    },
    {
        identifier: 'UpdateHelper\\',
        package: 'kylekatarnls/update-helper',
    },
    {
        identifier: 'Http\\Adapter\\',
        package: 'php-http/guzzle6-adapter',
    },
    {
        identifier: 'Symfony\\Bridge\\Monolog',
        package: 'symfony/monolog-bridge',
    },
    {
        identifier: 'Twig_Extensions_',
        package: 'twig/extensions',
    },
    {
        identifier: 'Google_Service_',
        package: 'google/apiclient-services',
    },
    {
        identifier: 'Symfony\\Component\\Asset\\',
        package: 'symfony/asset',
    },
    {
        identifier: 'PhpAmqpLib',
        package: 'php-amqplib/php-amqplib',
    },
    {
        identifier: 'Symfony\\Bundle\\SecurityBundle',
        package: 'symfony/security-bundle',
    },
    {
        identifier: 'Pimple',
        package: 'pimple/pimple',
    },
    {
        identifier: 'Symfony\\Contracts\\',
        package: 'symfony/contracts',
    },
    {
        identifier: 'Fig\\Link\\',
        package: 'fig/link-util',
    },
    {
        identifier: 'PHPStan\\PhpDocParser\\',
        package: 'phpstan/phpdoc-parser',
    },
    {
        identifier: 'Doctrine\\Common\\DataFixtures',
        package: 'doctrine/data-fixtures',
    },
    {
        identifier: 'JMS\\',
        package: 'jms/parser-lib',
    },
    {
        identifier: 'Cron',
        package: 'mtdowling/cron-expression',
    },
    {
        identifier: 'HTMLPurifier',
        package: 'ezyang/htmlpurifier',
    },
    {
        identifier: 'PHPStan\\',
        package: 'phpstan/phpstan',
    },
    {
        identifier: 'PhpCollection',
        package: 'phpcollection/phpcollection',
    },
    {
        identifier: 'Symfony\\Component\\Security\\Core\\',
        package: 'symfony/security-core',
    },
    {
        identifier: 'Gedmo',
        package: 'gedmo/doctrine-extensions',
    },
    {
        identifier: 'libphonenumber',
        package: 'giggsey/libphonenumber-for-php',
    },
    {
        identifier: 'Symfony\\Bundle\\WebProfilerBundle',
        package: 'symfony/web-profiler-bundle',
    },
    {
        identifier: 'Composer\\Installers\\',
        package: 'composer/installers',
    },
    {
        identifier: 'Symfony\\Component\\PropertyInfo\\',
        package: 'symfony/property-info',
    },
    {
        identifier: 'Negotiation',
        package: 'willdurand/negotiation',
    },
    {
        identifier: 'League\\Event\\',
        package: 'league/event',
    },
    {
        identifier: 'Giggsey\\Locale\\',
        package: 'giggsey/locale',
    },
    {
        identifier: 'Asm89\\Stack',
        package: 'asm89/stack-cors',
    },
    {
        identifier: 'Symfony\\Component\\HttpClient\\',
        package: 'symfony/http-client',
    },
    {
        identifier: 'Oauth2',
        package: 'league/oauth2-server',
    },
    {
        identifier: 'Sabberworm\\CSS',
        package: 'sabberworm/php-css-parser',
    },
    {
        identifier: 'org\\bovigo\\vfs',
        package: 'mikey179/vfsstream',
    },
    {
        identifier: 'Doctrine\\Bundle\\DoctrineFixturesBundle',
        package: 'doctrine/doctrine-fixtures-bundle',
    },
    {
        identifier: 'Psr\\Http\\Client\\',
        package: 'psr/http-client',
    },
    {
        identifier: 'Symfony\\Component\\Security\\Csrf\\',
        package: 'symfony/security-csrf',
    },
    {
        identifier: 'Http\\Curl\\',
        package: 'php-http/curl-client',
    },
    {
        identifier: 'Illuminate\\Contracts\\',
        package: 'illuminate/contracts',
    },
    {
        identifier: 'Illuminate\\Support',
        package: 'illuminate/support',
    },
    {
        identifier: 'Svg\\',
        package: 'phenx/php-svg-lib',
    },
    {
        identifier: 'Symfony\\Contracts\\HttpClient\\',
        package: 'symfony/http-client-contracts',
    },
    {
        identifier: 'PHPExcel',
        package: 'phpoffice/phpexcel',
    },
    {
        identifier: 'Bakame',
        package: 'league/csv',
    },
    {
        identifier: 'Facade\\IgnitionContracts\\',
        package: 'facade/ignition-contracts',
    },
    {
        identifier: 'JMS\\SerializerBundle',
        package: 'jms/serializer-bundle',
    },
    {
        identifier: 'Facade\\Ignition\\',
        package: 'facade/ignition',
    },
    {
        identifier: 'Facade\\FlareClient\\',
        package: 'facade/flare-client-php',
    },
    {
        identifier: 'Zend\\Validator\\',
        package: 'zendframework/zend-validator',
    },
    {
        identifier: 'Behat\\Mink',
        package: 'behat/mink',
    },
    {
        identifier: 'JsonpCallbackValidator',
        package: 'willdurand/jsonp-callback-validator',
    },
    {
        identifier: 'Guzzle',
        package: 'guzzle/guzzle',
    },
    {
        identifier: 'Incenteev\\ParameterHandler',
        package: 'incenteev/composer-parameter-handler',
    },
    {
        identifier: 'Sensio\\Bundle\\DistributionBundle',
        package: 'sensio/distribution-bundle',
    },
    {
        identifier: 'Symfony\\Component\\Security\\Http\\',
        package: 'symfony/security-http',
    },
    {
        identifier: 'Symfony\\Component\\Security\\Guard\\',
        package: 'symfony/security-guard',
    },
    {
        identifier: 'Highlight\\',
        package: 'scrivo/highlight.php',
    },
    {
        identifier: 'Mycsense',
        package: 'myclabs/php-enum',
    },
    {
        identifier: 'Namshi\\JOSE',
        package: 'namshi/jose',
    },
    {
        identifier: 'Barryvdh\\LaravelIdeHelper',
        package: 'barryvdh/laravel-ide-helper',
    },
    {
        identifier: 'Symfony\\Bundle\\MakerBundle\\',
        package: 'symfony/maker-bundle',
    },
    {
        identifier: 'DebugBar',
        package: 'maximebf/debugbar',
    },
    {
        identifier: 'Stripe',
        package: 'stripe/stripe-php',
    },
    {
        identifier: 'Collective\\Html\\',
        package: 'laravelcollective/html',
    },
    {
        identifier: 'Maatwebsite\\Excel',
        package: 'maatwebsite/excel',
    },
    {
        identifier: 'SuperClosure',
        package: 'jeremeamia/superclosure',
    },
    {
        identifier: 'Behat\\Behat',
        package: 'behat/behat',
    },
    {
        identifier: 'ParagonIE\\ConstantTime\\',
        package: 'paragonie/constant_time_encoding',
    },
    {
        identifier: 'BeyondCode\\DumpServer\\',
        package: 'beyondcode/laravel-dump-server',
    },
    {
        identifier: 'Barryvdh\\Debugbar',
        package: 'barryvdh/laravel-debugbar',
    },
    {
        identifier: 'Swagger',
        package: 'zircote/swagger-php',
    },
    {
        identifier: 'Goutte',
        package: 'fabpot/goutte',
    },
    {
        identifier: 'Stof\\DoctrineExtensionsBundle',
        package: 'stof/doctrine-extensions-bundle',
    },
    {
        identifier: 'phpDocumentor/Reflection',
        package: 'barryvdh/reflection-docblock',
    },
    {
        identifier: 'Assert',
        package: 'beberlei/assert',
    },
    {
        identifier: 'Zend\\Feed\\',
        package: 'zendframework/zend-feed',
    },
    {
        identifier: 'Behat\\Mink\\Driver',
        package: 'behat/mink-browserkit-driver',
    },
    {
        identifier: 'Webmozart\\PathUtil\\',
        package: 'webmozart/path-util',
    },
    {
        identifier: 'Hirak\\Prestissimo\\',
        package: 'hirak/prestissimo',
    },
    {
        identifier: 'FOS\\RestBundle',
        package: 'friendsofsymfony/rest-bundle',
    },
    {
        identifier: 'Codeception\\',
        package: 'codeception/stub',
    },
    {
        identifier: 'Symfony\\Bundle\\DebugBundle\\',
        package: 'symfony/debug-bundle',
    },
    {
        identifier: 'Rize\\UriTemplate',
        package: 'rize/uri-template',
    },
    {
        identifier: 'Codeception\\PHPUnit\\',
        package: 'codeception/phpunit-wrapper',
    },
    {
        identifier: 'WebDriver',
        package: 'instaclick/php-webdriver',
    },
    {
        identifier: 'Behat\\Mink\\Driver',
        package: 'behat/mink-selenium2-driver',
    },
    {
        identifier: 'ReCaptcha\\',
        package: 'google/recaptcha',
    },
    {
        identifier: 'Codeception',
        package: 'codeception/codeception',
    },
    {
        identifier: 'Illuminate\\Container',
        package: 'illuminate/container',
    },
    {
        identifier: 'Zend\\ServiceManager\\',
        package: 'zendframework/zend-servicemanager',
    },
    {
        identifier: 'Zend\\Loader\\',
        package: 'zendframework/zend-loader',
    },
    {
        identifier: 'PEAR',
        package: 'pear/pear_exception',
    },
    {
        identifier: 'Http\\Factory\\Guzzle\\',
        package: 'http-interop/http-factory-guzzle',
    },
    {
        identifier: 'Nelmio\\CorsBundle',
        package: 'nelmio/cors-bundle',
    },
    {
        identifier: 'Behat\\MinkExtension',
        package: 'behat/mink-extension',
    },
    {
        identifier: 'Cocur',
        package: 'cocur/slugify',
    },
    {
        identifier: 'Laravel\\Passport\\',
        package: 'laravel/passport',
    },
    {
        identifier: 'Dflydev\\DotAccessData',
        package: 'dflydev/dot-access-data',
    },
    {
        identifier: 'Assetic',
        package: 'kriswallsmith/assetic',
    },
    {
        identifier: 'Consolidation\\OutputFormatters\\',
        package: 'consolidation/output-formatters',
    },
    {
        identifier: 'League',
        package: 'league/fractal',
    },
    {
        identifier: 'Cake\\Chronos\\',
        package: 'cakephp/chronos',
    },
    {
        identifier: 'Consolidation\\AnnotationCommand\\',
        package: 'consolidation/annotated-command',
    },
    {
        identifier: 'Console',
        package: 'pear/console_getopt',
    },
    {
        identifier: 'Symfony\\Component\\WebLink\\',
        package: 'symfony/web-link',
    },
    {
        identifier: 'MaxMind',
        package: 'maxmind-db/reader',
    },
    {
        identifier: 'Zend\\Uri\\',
        package: 'zendframework/zend-uri',
    },
    {
        identifier: 'League\\Container\\',
        package: 'league/container',
    },
    {
        identifier: 'BaconQrCode',
        package: 'bacon/bacon-qr-code',
    },
    {
        identifier: 'Sensio\\Bundle\\GeneratorBundle',
        package: 'sensio/generator-bundle',
    },
    {
        identifier: 'Barryvdh\\Cors',
        package: 'barryvdh/laravel-cors',
    },
    {
        identifier: 'True\\',
        package: 'true/punycode',
    },
    {
        identifier: 'Knp\\Snappy',
        package: 'knplabs/knp-snappy',
    },
    {
        identifier: 'OAuth2',
        package: 'league/oauth2-client',
    },
    {
        identifier: 'Behat\\Mink\\Driver',
        package: 'behat/mink-goutte-driver',
    },
    {
        identifier: 'Zend\\Http\\',
        package: 'zendframework/zend-http',
    },
    {
        identifier: 'TYPO3\\PharStreamWrapper\\',
        package: 'typo3/phar-stream-wrapper',
    },
    {
        identifier: 'Nelmio\\ApiDocBundle',
        package: 'nelmio/api-doc-bundle',
    },
    {
        identifier: 'cweagans\\Composer\\',
        package: 'cweagans/composer-patches',
    },
    {
        identifier: 'Archive_Tar',
        package: 'pear/archive_tar',
    },
    {
        identifier: 'Services_Twilio',
        package: 'twilio/sdk',
    },
    {
        identifier: 'Zend\\Filter\\',
        package: 'zendframework/zend-filter',
    },
    {
        identifier: 'Google\\Cloud\\Core\\',
        package: 'google/cloud-core',
    },
    {
        identifier: 'Robo\\',
        package: 'consolidation/robo',
    },
    {
        identifier: 'GeoIP2',
        package: 'geoip2/geoip2',
    },
    {
        identifier: 'Symfony\\Cmf\\Component\\Routing',
        package: 'symfony-cmf/routing',
    },
    {
        identifier: 'Google\\',
        package: 'google/protobuf',
    },
    {
        identifier: 'HTML5',
        package: 'masterminds/html5',
    },
    {
        identifier: 'MaxMind\\',
        package: 'maxmind/web-service-common',
    },
    {
        identifier: 'Zend\\Json\\',
        package: 'zendframework/zend-json',
    },
    {
        identifier: 'DoctrineExtensions',
        package: 'beberlei/doctrineextensions',
    },
    {
        identifier: 'Sentry\\SentryLaravel\\',
        package: 'sentry/sentry-laravel',
    },
    {
        identifier: 'React\\EventLoop',
        package: 'react/event-loop',
    },
    {
        identifier: 'Moontoast\\Math',
        package: 'moontoast/math',
    },
    {
        identifier: 'Jaybizzle\\CrawlerDetect\\',
        package: 'jaybizzle/crawler-detect',
    },
    {
        identifier: 'Consolidation\\Log\\',
        package: 'consolidation/log',
    },
    {
        identifier: 'Drupal\\Core\\',
        package: 'drupal/core',
    },
    {
        identifier: 'Consolidation\\Config\\',
        package: 'consolidation/config',
    },
    {
        identifier: 'Pagerfanta\\',
        package: 'pagerfanta/pagerfanta',
    },
    {
        identifier: 'Grasmash\\YamlExpander\\',
        package: 'grasmash/yaml-expander',
    },
    {
        identifier: 'Grasmash\\Expander\\',
        package: 'grasmash/expander',
    },
    {
        identifier: 'Illuminate\\Notifications\\',
        package: 'laravel/slack-notification-channel',
    },
    {
        identifier: 'Zend\\Hydrator\\',
        package: 'zendframework/zend-hydrator',
    },
    {
        identifier: 'Knp\\Menu',
        package: 'knplabs/knp-menu',
    },
    {
        identifier: 'Diff',
        package: 'phpspec/php-diff',
    },
    {
        identifier: 'Hoa\\Stream',
        package: 'hoa/stream',
    },
    {
        identifier: 'SelfUpdate\\',
        package: 'consolidation/self-update',
    },
    {
        identifier: 'Hoa\\Iterator',
        package: 'hoa/iterator',
    },
    {
        identifier: 'Hoa\\Consistency\\',
        package: 'hoa/consistency',
    },
    {
        identifier: 'Hoa\\File',
        package: 'hoa/file',
    },
    {
        identifier: 'Hoa\\Exception\\',
        package: 'hoa/exception',
    },
    {
        identifier: 'Hoa\\Event\\',
        package: 'hoa/event',
    },
    {
        identifier: 'Hoa\\String',
        package: 'hoa/ustring',
    },
    {
        identifier: 'Knp\\Bundle\\MenuBundle',
        package: 'knplabs/knp-menu-bundle',
    },
    {
        identifier: 'Grpc\\',
        package: 'grpc/grpc',
    },
    {
        identifier: 'Hoa\\Protocol\\',
        package: 'hoa/protocol',
    },
    {
        identifier: 'EasyCorp\\EasyLog\\',
        package: 'easycorp/easy-log-handler',
    },
    {
        identifier: 'League\\OAuth1\\Client',
        package: 'league/oauth1-client',
    },
    {
        identifier: 'Pusher',
        package: 'pusher/pusher-php-server',
    },
    {
        identifier: 'Illuminate\\Database',
        package: 'illuminate/database',
    },
    {
        identifier: 'Laravel\\Socialite\\',
        package: 'laravel/socialite',
    },
    {
        identifier: 'Stack',
        package: 'stack/builder',
    },
    {
        identifier: 'MongoDB\\',
        package: 'mongodb/mongodb',
    },
    {
        identifier: 'Symfony\\Polyfill\\Php55\\',
        package: 'symfony/polyfill-php55',
    },
    {
        identifier: 'Symfony\\Component\\Security\\Acl\\',
        package: 'symfony/security-acl',
    },
    {
        identifier: 'FOS\\JsRoutingBundle',
        package: 'friendsofsymfony/jsrouting-bundle',
    },
    {
        identifier: 'Zend\\Mime\\',
        package: 'zendframework/zend-mime',
    },
    {
        identifier: 'Zend\\Config\\',
        package: 'zendframework/zend-config',
    },
    {
        identifier: 'Elastica',
        package: 'ruflin/elastica',
    },
    {
        identifier: 'Nelmio\\Alice\\',
        package: 'nelmio/alice',
    },
    {
        identifier: 'Symfony\\Polyfill\\Php54\\',
        package: 'symfony/polyfill-php54',
    },
    {
        identifier: 'EasyRdf',
        package: 'easyrdf/easyrdf',
    },
    {
        identifier: 'Zend\\InputFilter\\',
        package: 'zendframework/zend-inputfilter',
    },
    {
        identifier: 'Symfony\\Bundle\\WebServerBundle\\',
        package: 'symfony/web-server-bundle',
    },
    {
        identifier: 'Zend\\I18n\\',
        package: 'zendframework/zend-i18n',
    },
    {
        identifier: 'Illuminate\\Filesystem',
        package: 'illuminate/filesystem',
    },
    {
        identifier: 'Illuminate\\Events',
        package: 'illuminate/events',
    },
    {
        identifier: 'Braintree',
        package: 'braintree/braintree_php',
    },
    {
        identifier: 'Tymon\\JWTAuth',
        package: 'tymon/jwt-auth',
    },
    {
        identifier: 'Phinx',
        package: 'robmorgan/phinx',
    },
    {
        identifier: 'Money',
        package: 'moneyphp/money',
    },
    {
        identifier: 'Zend\\View\\',
        package: 'zendframework/zend-view',
    },
    {
        identifier: 'React\\Stream',
        package: 'react/stream',
    },
    {
        identifier: 'Barryvdh\\DomPDF',
        package: 'barryvdh/laravel-dompdf',
    },
    {
        identifier: 'Zend\\Mail\\',
        package: 'zendframework/zend-mail',
    },
    {
        identifier: 'Zend\\Math\\',
        package: 'zendframework/zend-math',
    },
    {
        identifier: 'FOS\\UserBundle',
        package: 'friendsofsymfony/user-bundle',
    },
    {
        identifier: 'Stecman\\Component',
        package: 'stecman/symfony-console-completion',
    },
    {
        identifier: 'Zend\\Serializer\\',
        package: 'zendframework/zend-serializer',
    },
    {
        identifier: 'Zend\\Server\\',
        package: 'zendframework/zend-server',
    },
    {
        identifier: 'Slim',
        package: 'slim/slim',
    },
    {
        identifier: 'Zend\\ModuleManager\\',
        package: 'zendframework/zend-modulemanager',
    },
    {
        identifier: 'Symfony\\Component\\Lock\\',
        package: 'symfony/lock',
    },
    {
        identifier: 'Google\\GAX\\',
        package: 'google/gax',
    },
    {
        identifier: 'React\\Socket',
        package: 'react/socket',
    },
    {
        identifier: 'Symfony\\Bundle\\AsseticBundle',
        package: 'symfony/assetic-bundle',
    },
    {
        identifier: 'Zend\\Log\\',
        package: 'zendframework/zend-log',
    },
    {
        identifier: 'Illuminate\\Config',
        package: 'illuminate/config',
    },
    {
        identifier: 'Symfony\\WebpackEncoreBundle\\',
        package: 'symfony/webpack-encore-bundle',
    },
    {
        identifier: 'Zend\\Form\\',
        package: 'zendframework/zend-form',
    },
    {
        identifier: 'Patchwork',
        package: 'patchwork/utf8',
    },
    {
        identifier: 'Google\\Cloud\\Storage\\',
        package: 'google/cloud-storage',
    },
    {
        identifier: 'Http\\Message\\MultipartStream\\',
        package: 'php-http/multipart-stream-builder',
    },
    {
        identifier: 'Buzz',
        package: 'kriswallsmith/buzz',
    },
    {
        identifier: 'Lexik\\Bundle\\JWTAuthenticationBundle',
        package: 'lexik/jwt-authentication-bundle',
    },
    {
        identifier: 'Zend\\Mvc\\',
        package: 'zendframework/zend-mvc',
    },
    {
        identifier: 'Zend\\Crypt\\',
        package: 'zendframework/zend-crypt',
    },
    {
        identifier: 'Zend\\Console\\',
        package: 'zendframework/zend-console',
    },
    {
        identifier: 'Zend\\Session\\',
        package: 'zendframework/zend-session',
    },
    {
        identifier: 'Spatie\\Permission\\',
        package: 'spatie/laravel-permission',
    },
    {
        identifier: 'Zend\\Db\\',
        package: 'zendframework/zend-db',
    },
    {
        identifier: 'JShrink',
        package: 'tedivm/jshrink',
    },
    {
        identifier: 'Zend\\Text\\',
        package: 'zendframework/zend-text',
    },
    {
        identifier: 'Illuminate\\View',
        package: 'illuminate/view',
    },
    {
        identifier: 'Laravel\\Horizon\\',
        package: 'laravel/horizon',
    },
    {
        identifier: 'Zend\\Soap\\',
        package: 'zendframework/zend-soap',
    },
    {
        identifier: 'Illuminate\\Notifications\\',
        package: 'laravel/nexmo-notification-channel',
    },
    {
        identifier: 'Illuminate\\Console',
        package: 'illuminate/console',
    },
    {
        identifier: 'Sentry\\SentryBundle\\',
        package: 'sentry/sentry-symfony',
    },
    {
        identifier: 'Seld\\CliPrompt\\',
        package: 'seld/cli-prompt',
    },
    {
        identifier: 'Credis',
        package: 'colinmollenhour/credis',
    },
    {
        identifier: 'Gaufrette',
        package: 'knplabs/gaufrette',
    },
    {
        identifier: 'Psr\\Http\\Server\\',
        package: 'psr/http-server-handler',
    },
    {
        identifier: 'Liip\\ImagineBundle',
        package: 'liip/imagine-bundle',
    },
    {
        identifier: 'React\\Dns',
        package: 'react/dns',
    },
    {
        identifier: 'Alchemy',
        package: 'alchemy/zippy',
    },
    {
        identifier: 'Flow\\JSONPath',
        package: 'flow/jsonpath',
    },
    {
        identifier: 'React\\Cache',
        package: 'react/cache',
    },
    {
        identifier: 'Knp\\Component',
        package: 'knplabs/knp-components',
    },
    {
        identifier: 'ClassPreloader',
        package: 'classpreloader/classpreloader',
    },
    {
        identifier: 'Ramsey\\Uuid\\Doctrine\\',
        package: 'ramsey/uuid-doctrine',
    },
    {
        identifier: 'Knp\\Bundle\\PaginatorBundle',
        package: 'knplabs/knp-paginator-bundle',
    },
    {
        identifier: 'Spatie\\TemporaryDirectory\\',
        package: 'spatie/temporary-directory',
    },
    {
        identifier: 'React\\Promise\\Timer\\',
        package: 'react/promise-timer',
    },
    {
        identifier: 'DrupalCodeGenerator\\',
        package: 'chi-teck/drupal-code-generator',
    },
    {
        identifier: 'Endroid',
        package: 'endroid/qr-code',
    },
    {
        identifier: 'Nyholm\\Psr7\\',
        package: 'nyholm/psr7',
    },
    {
        identifier: 'Mustache',
        package: 'mustache/mustache',
    },
    {
        identifier: 'Psr\\Http\\Server\\',
        package: 'psr/http-server-middleware',
    },
    {
        identifier: 'Jenssegers\\Agent',
        package: 'jenssegers/agent',
    },
    {
        identifier: 'Box\\Spout\\',
        package: 'box/spout',
    },
    {
        identifier: 'cebe\\markdown\\',
        package: 'cebe/markdown',
    },
    {
        identifier: 'Behat\\Symfony2Extension',
        package: 'behat/symfony2-extension',
    },
    {
        identifier: 'Grpc\\Gcp\\',
        package: 'google/grpc-gcp',
    },
    {
        identifier: 'Sabre\\Uri\\',
        package: 'sabre/uri',
    },
    {
        identifier: 'Pelago\\',
        package: 'pelago/emogrifier',
    },
    {
        identifier: 'DrupalComposer\\DrupalScaffold\\',
        package: 'drupal-composer/drupal-scaffold',
    },
    {
        identifier: 'Brumann\\Polyfill\\',
        package: 'brumann/polyfill-unserialize',
    },
    {
        identifier: 'Drupal\\Console\\Composer\\Plugin\\',
        package: 'drupal/console-extend-plugin',
    },
    {
        identifier: 'Drupal\\AppConsole',
        package: 'drupal/console',
    },
    {
        identifier: 'Drupal\\Console\\',
        package: 'drupal/console-core',
    },
    {
        identifier: 'Hashids',
        package: 'hashids/hashids',
    },
    {
        identifier: 'yii\\',
        package: 'yiisoft/yii2',
    },
    {
        identifier: 'Knp\\Bundle\\SnappyBundle',
        package: 'knplabs/knp-snappy-bundle',
    },
    {
        identifier: 'Symfony\\Component\\Messenger\\',
        package: 'symfony/messenger',
    },
    {
        identifier: 'Superbalist\\Flysystem\\GoogleStorage\\',
        package: 'superbalist/flysystem-google-storage',
    },
    {
        identifier: 'Spatie\\ImageOptimizer\\',
        package: 'spatie/image-optimizer',
    },
    {
        identifier: 'Illuminate\\Cache',
        package: 'illuminate/cache',
    },
    {
        identifier: 'JohnKary',
        package: 'johnkary/phpunit-speedtrap',
    },
    {
        identifier: 'PayPal',
        package: 'paypal/rest-api-sdk-php',
    },
    {
        identifier: 'League\\Glide\\',
        package: 'league/glide',
    },
    {
        identifier: 'Illuminate\\Session',
        package: 'illuminate/session',
    },
    {
        identifier: 'Zend\\Di\\',
        package: 'zendframework/zend-di',
    },
    {
        identifier: 'yii\\composer\\',
        package: 'yiisoft/yii2-composer',
    },
    {
        identifier: 'Illuminate\\',
        package: 'tightenco/collect',
    },
    {
        identifier: 'Hoa\\Visitor',
        package: 'hoa/visitor',
    },
    {
        identifier: 'Hoa\\Math',
        package: 'hoa/math',
    },
    {
        identifier: 'Hoa\\Compiler',
        package: 'hoa/compiler',
    },
    {
        identifier: 'Illuminate\\Pipeline\\',
        package: 'illuminate/pipeline',
    },
    {
        identifier: 'Hoa\\Regex',
        package: 'hoa/regex',
    },
    {
        identifier: 'Symfony\\Bridge\\ProxyManager\\',
        package: 'symfony/proxy-manager-bridge',
    },
    {
        identifier: 'Illuminate\\Translation',
        package: 'illuminate/translation',
    },
    {
        identifier: 'Google\\CRC32\\',
        package: 'google/crc32',
    },
    {
        identifier: 'Illuminate\\Queue',
        package: 'illuminate/queue',
    },
    {
        identifier: 'Google\\',
        package: 'google/common-protos',
    },
    {
        identifier: 'Illuminate\\Pagination',
        package: 'illuminate/pagination',
    },
    {
        identifier: 'Zend\\Psr7Bridge\\',
        package: 'zendframework/zend-psr7bridge',
    },
    {
        identifier: 'Illuminate\\Http',
        package: 'illuminate/http',
    },
    {
        identifier: 'Consolidation\\SiteAlias\\',
        package: 'consolidation/site-alias',
    },
    {
        identifier: 'Hoa\\Zformat\\',
        package: 'hoa/zformat',
    },
    {
        identifier: 'Dflydev\\DotAccessConfiguration',
        package: 'dflydev/dot-access-configuration',
    },
    {
        identifier: 'Zend\\Captcha\\',
        package: 'zendframework/zend-captcha',
    },
    {
        identifier: 'Dflydev\\PlaceholderResolver',
        package: 'dflydev/placeholder-resolver',
    },
    {
        identifier: 'Less',
        package: 'oyejorge/less.php',
    },
    {
        identifier: 'League\\Flysystem\\Sftp\\',
        package: 'league/flysystem-sftp',
    },
    {
        identifier: 'Sabre\\XML',
        package: 'sabre/xml',
    },
    {
        identifier: 'Invoker\\',
        package: 'php-di/invoker',
    },
    {
        identifier: 'PHPSpec\\',
        package: 'phpspec/phpspec',
    },
    {
        identifier: 'EXSyst\\Swagger\\',
        package: 'exsyst/swagger',
    },
    {
        identifier: 'SendGrid',
        package: 'sendgrid/php-http-client',
    },
    {
        identifier: 'UAParser\\',
        package: 'ua-parser/uap-php',
    },
    {
        identifier: 'Solarium',
        package: 'solarium/solarium',
    },
    {
        identifier: 'Zumba\\GastonJS\\',
        package: 'jcalderonzumba/gastonjs',
    },
    {
        identifier: 'Consolidation\\Filter\\',
        package: 'consolidation/filter-via-dot-access-data',
    },
    {
        identifier: 'PayWithAmazon\\',
        package: 'amzn/amazon-pay-sdk-php',
    },
    {
        identifier: 'Psr\\Event\\Dispatcher\\',
        package: 'psr/event-dispatcher',
    },
    {
        identifier: 'Illuminate\\Bus\\',
        package: 'illuminate/bus',
    },
    {
        identifier: 'Behat\\PhantomJSExtension\\',
        package: 'jcalderonzumba/mink-phantomjs-driver',
    },
    {
        identifier: 'AdvancedJsonRpc\\',
        package: 'felixfbecker/advanced-json-rpc',
    },
    {
        identifier: 'Sabre\\Event',
        package: 'sabre/event',
    },
    {
        identifier: 'Http\\Client\\Common\\Plugin\\',
        package: 'php-http/logger-plugin',
    },
    {
        identifier: 'Pheanstalk',
        package: 'pda/pheanstalk',
    },
    {
        identifier: 'Consolidation\\SiteProcess\\',
        package: 'consolidation/site-process',
    },
    {
        identifier: 'PHPStan\\',
        package: 'phpstan/phpstan-symfony',
    },
    {
        identifier: 'League\\Flysystem\\Cached\\',
        package: 'league/flysystem-cached-adapter',
    },
    {
        identifier: 'Dealerdirect\\Composer\\Plugin\\Installers\\PHPCodeSniffer\\',
        package: 'dealerdirect/phpcodesniffer-composer-installer',
    },
    {
        identifier: 'Mandrill',
        package: 'mandrill/mandrill',
    },
    {
        identifier: 'Zend',
        package: 'magento/zendframework1',
    },
    {
        identifier: 'Stringy',
        package: 'danielstjules/stringy',
    },
    {
        identifier: 'PHPStan\\',
        package: 'phpstan/phpstan-doctrine',
    },
    {
        identifier: 'PHPStan\\',
        package: 'phpstan/phpstan-phpunit',
    },
    {
        identifier: 'Knp\\Bundle\\GaufretteBundle',
        package: 'knplabs/knp-gaufrette-bundle',
    },
    {
        identifier: 'Gettext',
        package: 'gettext/gettext',
    },
    {
        identifier: 'Http\\Client\\Common\\Plugin\\',
        package: 'php-http/stopwatch-plugin',
    },
    {
        identifier: 'Illuminate\\Auth',
        package: 'illuminate/auth',
    },
    {
        identifier: 'Fig\\Http\\Message\\',
        package: 'fig/http-message-util',
    },
    {
        identifier: 'Fidry\\AliceDataFixtures\\',
        package: 'theofidry/alice-data-fixtures',
    },
    {
        identifier: 'League\\Uri\\',
        package: 'league/uri',
    },
    {
        identifier: 'Bllim\\Datatables',
        package: 'yajra/laravel-datatables-oracle',
    },
    {
        identifier: 'Laravel\\Dusk\\',
        package: 'laravel/dusk',
    },
    {
        identifier: 'OTPHP',
        package: 'spomky-labs/otphp',
    },
    {
        identifier: 'Illuminate\\Broadcasting\\',
        package: 'illuminate/broadcasting',
    },
    {
        identifier: 'Spatie\\Image\\',
        package: 'spatie/image',
    },
    {
        identifier: 'Http\\HttplugBundle\\',
        package: 'php-http/httplug-bundle',
    },
    {
        identifier: 'Geocoder',
        package: 'willdurand/geocoder',
    },
    {
        identifier: 'Bugsnag\\BugsnagLaravel\\',
        package: 'bugsnag/bugsnag-laravel',
    },
    {
        identifier: 'GettextLanguages\\',
        package: 'gettext/languages',
    },
    {
        identifier: 'OAuth',
        package: 'lusitanian/oauth',
    },
    {
        identifier: 'Laravel\\Ui\\',
        package: 'laravel/ui',
    },
    {
        identifier: 'Laravel\\Lumen\\',
        package: 'laravel/lumen-framework',
    },
    {
        identifier: 'Laravel\\Telescope\\',
        package: 'laravel/telescope',
    },
    {
        identifier: 'Interop\\Queue\\',
        package: 'queue-interop/queue-interop',
    },
    {
        identifier: 'Aws\\Laravel',
        package: 'aws/aws-sdk-php-laravel',
    },
    {
        identifier: 'OldSound\\RabbitMqBundle\\',
        package: 'php-amqplib/rabbitmq-bundle',
    },
    {
        identifier: 'yii\\swiftmailer\\',
        package: 'yiisoft/yii2-swiftmailer',
    },
    {
        identifier: 'yii\\debug\\',
        package: 'yiisoft/yii2-debug',
    },
    {
        identifier: 'Symfony\\Thanks\\',
        package: 'symfony/thanks',
    },
    {
        identifier: 'Cake\\Utility\\',
        package: 'cakephp/utility',
    },
    {
        identifier: 'Cm\\RedisSession\\',
        package: 'colinmollenhour/php-redis-session-abstract',
    },
    {
        identifier: 'Dunglas\\ApiBundle\\',
        package: 'api-platform/core',
    },
    {
        identifier: 'Wikimedia\\Composer\\',
        package: 'wikimedia/composer-merge-plugin',
    },
    {
        identifier: 'Cake\\Core\\',
        package: 'cakephp/core',
    },
    {
        identifier: 'SecurityLib',
        package: 'ircmaxell/security-lib',
    },
    {
        identifier: 'Mailgun\\Tests',
        package: 'mailgun/mailgun-php',
    },
    {
        identifier: 'Sabre\\VObject',
        package: 'sabre/vobject',
    },
    {
        identifier: 'Bugsnag\\PsrLogger\\',
        package: 'bugsnag/bugsnag-psr-logger',
    },
    {
        identifier: 'League\\Uri\\',
        package: 'league/uri-parser',
    },
    {
        identifier: 'Sonata\\CoreBundle',
        package: 'sonata-project/core-bundle',
    },
    {
        identifier: 'Alert',
        package: 'amphp/amp',
    },
    {
        identifier: 'WhiteOctober\\PagerfantaBundle',
        package: 'white-october/pagerfanta-bundle',
    },
    {
        identifier: 'CG\\',
        package: 'jms/cg',
    },
    {
        identifier: 'Zend\\Barcode\\',
        package: 'zendframework/zend-barcode',
    },
    {
        identifier: 'Oneup\\FlysystemBundle',
        package: 'oneup/flysystem-bundle',
    },
    {
        identifier: 'Sonata\\BlockBundle',
        package: 'sonata-project/block-bundle',
    },
    {
        identifier: 'MagentoHackathon\\Composer\\Magento',
        package: 'magento/magento-composer-installer',
    },
    {
        identifier: 'Deployer\\',
        package: 'deployer/deployer',
    },
    {
        identifier: 'Cache\\Adapter\\Common\\',
        package: 'cache/adapter-common',
    },
    {
        identifier: 'Base32',
        package: 'christian-riesen/base32',
    },
    {
        identifier: 'League\\Uri\\Interfaces\\',
        package: 'league/uri-interfaces',
    },
    {
        identifier: 'mikehaertl\\shellcommand\\',
        package: 'mikehaertl/php-shellcommand',
    },
    {
        identifier: 'League\\ISO3166\\',
        package: 'league/iso3166',
    },
    {
        identifier: 'ZendDiagnostics\\',
        package: 'zendframework/zenddiagnostics',
    },
    {
        identifier: 'Cache\\TagInterop\\',
        package: 'cache/tag-interop',
    },
    {
        identifier: 'Hoa\\Console',
        package: 'hoa/console',
    },
    {
        identifier: 'Respect\\Validation',
        package: 'respect/validation',
    },
    {
        identifier: 'Habitat',
        package: 'brianium/habitat',
    },
    {
        identifier: 'Base64Url\\',
        package: 'spomky-labs/base64url',
    },
    {
        identifier: 'Sonata\\Cache\\',
        package: 'sonata-project/cache',
    },
    {
        identifier: 'yii\\bootstrap\\',
        package: 'yiisoft/yii2-bootstrap',
    },
    {
        identifier: 'ParaTest',
        package: 'brianium/paratest',
    },
    {
        identifier: 'Sonata\\DatagridBundle\\',
        package: 'sonata-project/datagrid-bundle',
    },
    {
        identifier: 'Vich\\UploaderBundle',
        package: 'vich/uploader-bundle',
    },
    {
        identifier: 'Cake\\Collection\\',
        package: 'cakephp/collection',
    },
    {
        identifier: 'League\\Uri\\Schemes\\',
        package: 'league/uri-schemes',
    },
    {
        identifier: 'HWI\\Bundle\\OAuthBundle',
        package: 'hwi/oauth-bundle',
    },
    {
        identifier: 'Sonata\\Doctrine\\Types',
        package: 'sonata-project/doctrine-extensions',
    },
    {
        identifier: 'Html2Text',
        package: 'html2text/html2text',
    },
    {
        identifier: 'Webmozart\\Glob\\',
        package: 'webmozart/glob',
    },
    {
        identifier: 'Cake\\Cache\\',
        package: 'cakephp/cache',
    },
    {
        identifier: 'Cake\\Datasource\\',
        package: 'cakephp/datasource',
    },
    {
        identifier: 'zaporylie\\ComposerDrupalOptimizations\\',
        package: 'zaporylie/composer-drupal-optimizations',
    },
    {
        identifier: 'Cake\\Database\\',
        package: 'cakephp/database',
    },
    {
        identifier: 'Zend\\Cache\\',
        package: 'zendframework/zend-cache',
    },
    {
        identifier: 'Deployer\\Component\\PharUpdate\\',
        package: 'deployer/phar-update',
    },
    {
        identifier: 'Requests',
        package: 'rmccue/requests',
    },
    {
        identifier: 'Interop\\Amqp\\',
        package: 'queue-interop/amqp-interop',
    },
    {
        identifier: 'League\\Uri\\Components\\',
        package: 'league/uri-components',
    },
    {
        identifier: 'Symfony\\Component\\Workflow\\',
        package: 'symfony/workflow',
    },
    {
        identifier: 'Hautelook\\AliceBundle',
        package: 'hautelook/alice-bundle',
    },
    {
        identifier: 'Illuminate\\Log',
        package: 'illuminate/log',
    },
    {
        identifier: 'Webpatser\\Uuid',
        package: 'webpatser/laravel-uuid',
    },
    {
        identifier: 'Cake\\Log\\',
        package: 'cakephp/log',
    },
    {
        identifier: 'PhpDocReader',
        package: 'php-di/phpdoc-reader',
    },
    {
        identifier: 'ForceUTF8\\',
        package: 'neitanod/forceutf8',
    },
    {
        identifier: 'Amp\\ByteStream\\',
        package: 'amphp/byte-stream',
    },
    {
        identifier: 'League\\Uri\\PublicSuffix\\',
        package: 'league/uri-hostname-parser',
    },
    {
        identifier: 'DASPRiD\\Enum\\',
        package: 'dasprid/enum',
    },
    {
        identifier: 'Laravel\\Scout\\',
        package: 'laravel/scout',
    },
    {
        identifier: 'Exporter',
        package: 'sonata-project/exporter',
    },
    {
        identifier: 'PHPStan\\',
        package: 'phpstan/phpstan-strict-rules',
    },
    {
        identifier: 'Magento\\Composer\\',
        package: 'magento/composer',
    },
    {
        identifier: 'Drewm',
        package: 'drewm/mailchimp-api',
    },
    {
        identifier: 'OAuth2',
        package: 'friendsofsymfony/oauth2-php',
    },
    {
        identifier: 'League\\Uri\\Modifiers\\',
        package: 'league/uri-manipulations',
    },
    {
        identifier: 'Spatie\\PdfToImage\\',
        package: 'spatie/pdf-to-image',
    },
    {
        identifier: 'yii\\gii\\',
        package: 'yiisoft/yii2-gii',
    },
    {
        identifier: 'Ratchet\\Tests',
        package: 'cboden/ratchet',
    },
    {
        identifier: 'CommerceGuys\\Addressing\\',
        package: 'commerceguys/addressing',
    },
    {
        identifier: 'Symfony\\Component\\Mailer\\',
        package: 'symfony/mailer',
    },
    {
        identifier: 'Ratchet\\WebSocket\\',
        package: 'ratchet/rfc6455',
    },
    {
        identifier: 'Silex',
        package: 'silex/silex',
    },
    {
        identifier: 'FOS\\OAuthServerBundle',
        package: 'friendsofsymfony/oauth-server-bundle',
    },
    {
        identifier: 'Sonata\\AdminBundle',
        package: 'sonata-project/admin-bundle',
    },
    {
        identifier: 'PhpOffice\\Common\\',
        package: 'phpoffice/common',
    },
    {
        identifier: 'FOS\\ElasticaBundle',
        package: 'friendsofsymfony/elastica-bundle',
    },
    {
        identifier: 'Barryvdh\\Snappy',
        package: 'barryvdh/laravel-snappy',
    },
    {
        identifier: 'Misd\\PhoneNumberBundle',
        package: 'misd/phone-number-bundle',
    },
    {
        identifier: 'Spatie\\Once\\',
        package: 'spatie/once',
    },
    {
        identifier: 'DI',
        package: 'php-di/php-di',
    },
    {
        identifier: 'PHPWord',
        package: 'phpoffice/phpword',
    },
    {
        identifier: 'Enqueue\\AmqpTools\\',
        package: 'enqueue/amqp-tools',
    },
    {
        identifier: 'RandomLib',
        package: 'ircmaxell/random-lib',
    },
    {
        identifier: 'Oro\\DBAL',
        package: 'oro/doctrine-extensions',
    },
    {
        identifier: 'Httpful',
        package: 'nategood/httpful',
    },
    {
        identifier: 'Underscore',
        package: 'anahkiasen/underscore-php',
    },
    {
        identifier: 'Zendesk\\API\\',
        package: 'zendesk/zendesk_api_client_php',
    },
    {
        identifier: 'Sonata\\DoctrineORMAdminBundle',
        package: 'sonata-project/doctrine-orm-admin-bundle',
    },
    {
        identifier: 'Doctrine\\ODM\\MongoDB',
        package: 'doctrine/mongodb-odm',
    },
    {
        identifier: 'Yandex',
        package: 'allure-framework/allure-php-api',
    },
    {
        identifier: 'Psalm\\',
        package: 'vimeo/psalm',
    },
    {
        identifier: 'OomphInc\\ComposerInstallersExtender\\',
        package: 'oomphinc/composer-installers-extender',
    },
    {
        identifier: 'PHPStan\\',
        package: 'phpstan/phpstan-deprecation-rules',
    },
    {
        identifier: 'mikehaertl\\tmp\\',
        package: 'mikehaertl/php-tmpfile',
    },
    {
        identifier: 'PragmaRX\\Google2FA\\',
        package: 'pragmarx/google2fa',
    },
    {
        identifier: 'Symfony\\Polyfill\\Intl\\Normalizer\\',
        package: 'symfony/polyfill-intl-normalizer',
    },
    {
        identifier: 'Enqueue\\',
        package: 'enqueue/enqueue',
    },
    {
        identifier: 'Enqueue\\Dsn\\',
        package: 'enqueue/dsn',
    },
    {
        identifier: 'Omnipay\\Common\\',
        package: 'omnipay/common',
    },
    {
        identifier: 'Google\\Cloud\\',
        package: 'google/cloud',
    },
    {
        identifier: 'Symfony\\Polyfill\\Intl\\Grapheme\\',
        package: 'symfony/polyfill-intl-grapheme',
    },
    {
        identifier: 'Propaganistas\\LaravelPhone',
        package: 'propaganistas/laravel-phone',
    },
    {
        identifier: 'Enqueue\\Null\\',
        package: 'enqueue/null',
    },
    {
        identifier: 'JMS\\AopBundle',
        package: 'jms/aop-bundle',
    },
    {
        identifier: 'yii\\faker\\',
        package: 'yiisoft/yii2-faker',
    },
    {
        identifier: 'GuzzleHttp\\Psr7\\',
        package: 'ringcentral/psr7',
    },
    {
        identifier: 'Laracasts\\Flash',
        package: 'laracasts/flash',
    },
    {
        identifier: 'Maknz\\Slack\\',
        package: 'maknz/slack',
    },
    {
        identifier: 'Gitonomy\\Git',
        package: 'gitonomy/gitlib',
    },
    {
        identifier: 'Intercom',
        package: 'intercom/intercom-php',
    },
    {
        identifier: 'LanguageServerProtocol\\',
        package: 'felixfbecker/language-server-protocol',
    },
    {
        identifier: 'ComponentInstaller',
        package: 'robloach/component-installer',
    },
    {
        identifier: 'Aws\\Symfony\\',
        package: 'aws/aws-sdk-php-symfony',
    },
    {
        identifier: 'Cache\\Hierarchy\\',
        package: 'cache/hierarchical-cache',
    },
    {
        identifier: 'Twig\\Extra\\TwigExtraBundle\\',
        package: 'twig/extra-bundle',
    },
    {
        identifier: 'GrahamCampbell\\Manager\\',
        package: 'graham-campbell/manager',
    },
    {
        identifier: 'Ekino\\Bundle\\NewRelicBundle',
        package: 'ekino/newrelic-bundle',
    },
    {
        identifier: 'Spatie\\DbDumper\\',
        package: 'spatie/db-dumper',
    },
    {
        identifier: 'Http\\Client\\Common\\Plugin\\',
        package: 'php-http/cache-plugin',
    },
    {
        identifier: 'KubAT\\PhpSimple\\HtmlDomParser',
        package: 'kub-at/php-simple-html-dom-parser',
    },
    {
        identifier: 'ColinODell\\CommonMark\\',
        package: 'league/commonmark',
    },
    {
        identifier: 'SAML2_',
        package: 'simplesamlphp/saml2',
    },
    {
        identifier: 'Safe\\',
        package: 'thecodingmachine/safe',
    },
    {
        identifier: 'JMS\\DiExtraBundle',
        package: 'jms/di-extra-bundle',
    },
    {
        identifier: 'Spatie\\String\\',
        package: 'spatie/string',
    },
    {
        identifier: 'Doctrine\\MongoDB',
        package: 'doctrine/mongodb',
    },
    {
        identifier: 'Nexmo\\',
        package: 'nexmo/client-core',
    },
    {
        identifier: 'Inflect',
        package: 'mmucklo/inflect',
    },
    {
        identifier: 'Spatie\\MediaLibrary\\',
        package: 'spatie/laravel-medialibrary',
    },
    {
        identifier: 'Abraham\\TwitterOAuth\\',
        package: 'abraham/twitteroauth',
    },
    {
        identifier: 'Spatie\\Activitylog\\',
        package: 'spatie/laravel-activitylog',
    },
    {
        identifier: 'PHPStan\\ExtensionInstaller\\',
        package: 'phpstan/extension-installer',
    },
    {
        identifier: 'Drupal\\Component',
        package: 'drupal/drupal-driver',
    },
    {
        identifier: 'EightPoints\\Bundle\\GuzzleBundle',
        package: 'eightpoints/guzzle-bundle',
    },
    {
        identifier: 'Yandex',
        package: 'allure-framework/allure-phpunit',
    },
    {
        identifier: 'FOS\\HttpCache\\',
        package: 'friendsofsymfony/http-cache',
    },
    {
        identifier: 'OwenIt\\Auditing\\',
        package: 'owen-it/laravel-auditing',
    },
    {
        identifier: 'MatthiasMullie\\PathConverter\\',
        package: 'matthiasmullie/path-converter',
    },
    {
        identifier: 'Symplify\\PackageBuilder\\',
        package: 'symplify/package-builder',
    },
    {
        identifier: 'Bazinga\\ExposeTranslationBundle',
        package: 'willdurand/js-translation-bundle',
    },
    {
        identifier: 'WebSocket\\',
        package: 'textalk/websocket',
    },
    {
        identifier: 'OAuth2',
        package: 'bshaffer/oauth2-server-php',
    },
    {
        identifier: 'Enqueue\\Bundle\\',
        package: 'enqueue/enqueue-bundle',
    },
    {
        identifier: 'Caxy\\HtmlDiff',
        package: 'caxy/php-htmldiff',
    },
    {
        identifier: 'Jenssegers\\Date',
        package: 'jenssegers/date',
    },
    {
        identifier: 'Sabre',
        package: 'sabre/dav',
    },
    {
        identifier: 'Drupal\\DrupalExtension',
        package: 'drupal/drupal-extension',
    },
    {
        identifier: 'WhiteHat101\\Crypt\\',
        package: 'whitehat101/apr1-md5',
    },
    {
        identifier: 'Zend\\Paginator\\',
        package: 'zendframework/zend-paginator',
    },
    {
        identifier: 'Domnikl',
        package: 'domnikl/statsd',
    },
    {
        identifier: 'SimpleSAML_',
        package: 'simplesamlphp/simplesamlphp',
    },
    {
        identifier: 'Sabre\\HTTP',
        package: 'sabre/http',
    },
    {
        identifier: 'JoeTannenbaum\\CLImate',
        package: 'league/climate',
    },
    {
        identifier: 'Spatie\\Fractal\\',
        package: 'spatie/laravel-fractal',
    },
    {
        identifier: 'ONGR\\ElasticsearchDSL\\',
        package: 'ongr/elasticsearch-dsl',
    },
    {
        identifier: 'Zend\\Authentication\\',
        package: 'zendframework/zend-authentication',
    },
    {
        identifier: 'Microsoft\\PhpParser\\',
        package: 'microsoft/tolerant-php-parser',
    },
    {
        identifier: 'DaveJamesMiller\\Breadcrumbs',
        package: 'davejamesmiller/laravel-breadcrumbs',
    },
    {
        identifier: 'ZendXml',
        package: 'zendframework/zendxml',
    },
    {
        identifier: 'Tree',
        package: 'nicmart/tree',
    },
    {
        identifier: 'Illuminate\\Redis',
        package: 'illuminate/redis',
    },
    {
        identifier: 'Silly\\',
        package: 'mnapoli/silly',
    },
    {
        identifier: 'Nelmio\\SecurityBundle',
        package: 'nelmio/security-bundle',
    },
    {
        identifier: 'Spatie\\Fractalistic\\',
        package: 'spatie/fractalistic',
    },
    {
        identifier: 'Phan\\',
        package: 'phan/phan',
    },
    {
        identifier: 'FOS\\HttpCacheBundle\\',
        package: 'friendsofsymfony/http-cache-bundle',
    },
    {
        identifier: 'cogpowered\\FineDiff',
        package: 'cogpowered/finediff',
    },
    {
        identifier: 'Spatie\\DatabaseBackup\\',
        package: 'spatie/laravel-backup',
    },
    {
        identifier: 'Asm89\\Twig\\CacheExtension\\',
        package: 'asm89/twig-cache-extension',
    },
    {
        identifier: 'Aura\\Intl',
        package: 'aura/intl',
    },
    {
        identifier: 'Rap2hpoutre\\LaravelLogViewer\\',
        package: 'rap2hpoutre/laravel-log-viewer',
    },
    {
        identifier: 'ParsedownExtra',
        package: 'erusev/parsedown-extra',
    },
    {
        identifier: 'Codeception\\',
        package: 'codeception/specify',
    },
    {
        identifier: 'Ivory\\HttpAdapter\\',
        package: 'egeloen/http-adapter',
    },
    {
        identifier: 'Codedungeon\\PHPUnitPrettyResultPrinter\\',
        package: 'codedungeon/phpunit-result-printer',
    },
    {
        identifier: 'Spatie\\Browsershot',
        package: 'spatie/browsershot',
    },
    {
        identifier: 'Less',
        package: 'wikimedia/less.php',
    },
    {
        identifier: 'TYPO3Fluid\\Fluid\\',
        package: 'typo3fluid/fluid',
    },
    {
        identifier: 'Prometheus\\',
        package: 'jimdo/prometheus_client_php',
    },
    {
        identifier: 'GrumPHP\\',
        package: 'phpro/grumphp',
    },
    {
        identifier: 'Sonata\\IntlBundle',
        package: 'sonata-project/intl-bundle',
    },
    {
        identifier: 'Jose\\Component\\Core\\',
        package: 'web-token/jwt-core',
    },
    {
        identifier: 'Darkaonline\\L5Swagger\\',
        package: 'darkaonline/l5-swagger',
    },
    {
        identifier: 'Kreait\\Firebase\\',
        package: 'kreait/firebase-php',
    },
    {
        identifier: 'Blackfire',
        package: 'blackfire/php-sdk',
    },
    {
        identifier: 'malkusch\\phpmock\\',
        package: 'php-mock/php-mock',
    },
    {
        identifier: 'NunoMaduro\\Larastan\\',
        package: 'nunomaduro/larastan',
    },
    {
        identifier: 'Pdp',
        package: 'jeremykendall/php-domain-parser',
    },
    {
        identifier: 'M1\\Env\\',
        package: 'm1/env',
    },
    {
        identifier: 'AndyWendt\\Socialite\\Extender\\',
        package: 'socialiteproviders/manager',
    },
    {
        identifier: 'Jose\\Component\\Signature\\',
        package: 'web-token/jwt-signature',
    },
    {
        identifier: 'JavierEguiluz\\Bundle\\EasyAdminBundle\\',
        package: 'easycorp/easyadmin-bundle',
    },
    {
        identifier: 'Ajgl\\Twig\\Extension\\',
        package: 'ajgl/breakpoint-twig-extension',
    },
    {
        identifier: 'Symplify\\CodingStandard\\',
        package: 'symplify/coding-standard',
    },
    {
        identifier: 'Firebase\\Auth\\Token\\',
        package: 'kreait/firebase-tokens',
    },
    {
        identifier: 'Laravel\\Cashier\\',
        package: 'laravel/cashier',
    },
    {
        identifier: 'Sanpi\\Behatch',
        package: 'behatch/contexts',
    },
    {
        identifier: 'Orchestra\\Testbench\\',
        package: 'orchestra/testbench-core',
    },
    {
        identifier: 'GoetasWebservices\\Xsd\\XsdToPhpRuntime\\',
        package: 'goetas-webservices/xsd2php-runtime',
    },
    {
        identifier: 'JSqueeze',
        package: 'patchwork/jsqueeze',
    },
    {
        identifier: 'Migrations\\',
        package: 'cakephp/migrations',
    },
    {
        identifier: 'Liip\\FunctionalTestBundle',
        package: 'liip/functional-test-bundle',
    },
    {
        identifier: 'Riverline\\MultiPartParser',
        package: 'riverline/multipart-parser',
    },
    {
        identifier: 'Cake\\Composer\\',
        package: 'cakephp/plugin-installer',
    },
    {
        identifier: 'League\\Flysystem\\Memory\\',
        package: 'league/flysystem-memory',
    },
    {
        identifier: 'Symplify\\EasyCodingStandard\\',
        package: 'symplify/easy-coding-standard',
    },
    {
        identifier: 'Aws\\Sns\\',
        package: 'aws/aws-php-sns-message-validator',
    },
    {
        identifier: 'Liip\\MonitorBundle',
        package: 'liip/monitor-bundle',
    },
    {
        identifier: 'Orchestra\\Testbench',
        package: 'orchestra/testbench',
    },
    {
        identifier: 'League\\Tactician\\',
        package: 'league/tactician',
    },
    {
        identifier: 'Jose\\Component\\Signature\\Algorithm\\',
        package: 'web-token/jwt-signature-algorithm-rsa',
    },
    {
        identifier: 'Smalot\\PdfParser\\',
        package: 'smalot/pdfparser',
    },
    {
        identifier: 'JaimePerez\\TwigConfigurableI18n\\',
        package: 'jaimeperez/twig-configurable-i18n',
    },
    {
        identifier: 'Yandex',
        package: 'allure-framework/allure-codeception',
    },
    {
        identifier: 'React\\HttpClient',
        package: 'react/http-client',
    },
    {
        identifier: 'Spatie\\ArrayToXml\\',
        package: 'spatie/array-to-xml',
    },
    {
        identifier: 'Zend\\Permissions\\Acl\\',
        package: 'zendframework/zend-permissions-acl',
    },
    {
        identifier: 'Prettus\\Repository\\',
        package: 'prettus/l5-repository',
    },
    {
        identifier: 'Laravel\\BrowserKitTesting\\',
        package: 'laravel/browser-kit-testing',
    },
    {
        identifier: 'yii\\redis\\',
        package: 'yiisoft/yii2-redis',
    },
    {
        identifier: 'Knp\\DoctrineBehaviors',
        package: 'knplabs/doctrine-behaviors',
    },
    {
        identifier: 'Jose\\Component\\Signature\\Algorithm\\',
        package: 'web-token/jwt-signature-algorithm-ecdsa',
    },
    {
        identifier: 'Hateoas',
        package: 'willdurand/hateoas',
    },
    {
        identifier: 'johnpbloch\\Composer\\',
        package: 'johnpbloch/wordpress-core-installer',
    },
    {
        identifier: 'Prettus\\Validator',
        package: 'prettus/laravel-validation',
    },
    {
        identifier: 'kartik\\base\\',
        package: 'kartik-v/yii2-krajee-base',
    },
    {
        identifier: 'Neutron',
        package: 'neutron/temporary-filesystem',
    },
    {
        identifier: 'FOS\\CKEditorBundle\\',
        package: 'friendsofsymfony/ckeditor-bundle',
    },
    {
        identifier: 'Magento\\FunctionalTestingFramework\\',
        package: 'magento/magento2-functional-testing-framework',
    },
    {
        identifier: 'Jose\\Component\\Signature\\Algorithm\\',
        package: 'web-token/jwt-signature-algorithm-eddsa',
    },
    {
        identifier: 'zhuravljov\\yii\\queue\\',
        package: 'yiisoft/yii2-queue',
    },
    {
        identifier: 'Alchemy',
        package: 'alchemy/binary-driver',
    },
    {
        identifier: 'Bake\\',
        package: 'cakephp/bake',
    },
    {
        identifier: 'SensioLabs\\Behat\\PageObjectExtension\\',
        package: 'sensiolabs/behat-page-object-extension',
    },
    {
        identifier: 'yii\\httpclient\\',
        package: 'yiisoft/yii2-httpclient',
    },
    {
        identifier: 'Google\\Authenticator',
        package: 'sonata-project/google-authenticator',
    },
    {
        identifier: 'Jose\\Component\\Signature\\Algorithm\\',
        package: 'web-token/jwt-signature-algorithm-hmac',
    },
    {
        identifier: 'Kevinrob\\GuzzleCache\\',
        package: 'kevinrob/guzzle-cache-middleware',
    },
    {
        identifier: 'Jose\\Component\\Signature\\Algorithm\\',
        package: 'web-token/jwt-signature-algorithm-none',
    },
    {
        identifier: 'Bamarni\\Composer\\Bin\\',
        package: 'bamarni/composer-bin-plugin',
    },
    {
        identifier: 'DMore\\ChromeDriver\\',
        package: 'dmore/chrome-mink-driver',
    },
    {
        identifier: 'josegonzalez\\Dotenv',
        package: 'josegonzalez/dotenv',
    },
    {
        identifier: 'Geocoder\\Http\\',
        package: 'geocoder-php/common-http',
    },
    {
        identifier: 'Jenssegers\\Mongodb',
        package: 'jenssegers/mongodb',
    },
    {
        identifier: 'Jose\\Component\\Core\\Util\\Ecc\\',
        package: 'web-token/jwt-util-ecc',
    },
    {
        identifier: 'React\\Promise\\Stream\\',
        package: 'react/promise-stream',
    },
    {
        identifier: 'Bazinga\\Bundle\\HateoasBundle',
        package: 'willdurand/hateoas-bundle',
    },
    {
        identifier: 'SimpleSoftwareIO\\',
        package: 'simplesoftwareio/simple-qrcode',
    },
    {
        identifier: 'Browser',
        package: 'sinergi/browser-detector',
    },
    {
        identifier: 'TYPO3\\ClassAliasLoader\\',
        package: 'typo3/class-alias-loader',
    },
    {
        identifier: 'Codeception',
        package: 'codeception/base',
    },
    {
        identifier: 'Eloquent',
        package: 'eloquent/enumeration',
    },
    {
        identifier: 'Mageplaza\\Core\\',
        package: 'mageplaza/module-core',
    },
    {
        identifier: 'Symfony\\Cmf\\Bundle\\RoutingBundle',
        package: 'symfony-cmf/routing-bundle',
    },
    {
        identifier: 'jarnaiz\\JUnitFormatter\\',
        package: 'jarnaiz/behat-junit-formatter',
    },
    {
        identifier: 'Aptoma',
        package: 'aptoma/twig-markdown',
    },
    {
        identifier: 'DAMA\\DoctrineTestBundle\\',
        package: 'dama/doctrine-test-bundle',
    },
    {
        identifier: 'GuzzleHttp\\Subscriber\\Oauth\\',
        package: 'guzzlehttp/oauth-subscriber',
    },
    {
        identifier: 'Picqer\\Barcode\\',
        package: 'picqer/php-barcode-generator',
    },
    {
        identifier: 'FFMpeg',
        package: 'php-ffmpeg/php-ffmpeg',
    },
    {
        identifier: 'kartik\\select2\\',
        package: 'kartik-v/yii2-widget-select2',
    },
    {
        identifier: 'Laravel\\Homestead\\',
        package: 'laravel/homestead',
    },
    {
        identifier: 'DMore\\ChromeExtension\\',
        package: 'dmore/behat-chrome-extension',
    },
    {
        identifier: 'Zend\\Mvc\\Router\\',
        package: 'zendframework/zend-router',
    },
    {
        identifier: 'ass\\XmlSecurity',
        package: 'ass/xmlsecurity',
    },
    {
        identifier: 'Sunra\\PhpSimple\\HtmlDomParser',
        package: 'sunra/php-simple-html-dom-parser',
    },
    {
        identifier: 'Clockwork',
        package: 'itsgoingd/clockwork',
    },
    {
        identifier: 'Lexik\\Bundle\\MaintenanceBundle',
        package: 'lexik/maintenance-bundle',
    },
    {
        identifier: 'Jasny\\Twig',
        package: 'jasny/twig-extensions',
    },
    {
        identifier: 'AESKW\\',
        package: 'spomky-labs/aes-key-wrap',
    },
    {
        identifier: 'MyBuilder\\PhpunitAccelerator\\',
        package: 'mybuilder/phpunit-accelerator',
    },
    {
        identifier: 'TheIconic\\Tracking\\GoogleAnalytics\\',
        package: 'theiconic/php-ga-measurement-protocol',
    },
    {
        identifier: 'Dingo\\Api\\',
        package: 'dingo/api',
    },
    {
        identifier: 'Eluceo\\iCal',
        package: 'eluceo/ical',
    },
    {
        identifier: 'Dingo\\Blueprint\\',
        package: 'dingo/blueprint',
    },
    {
        identifier: 'Kreait\\',
        package: 'kreait/gcp-metadata',
    },
    {
        identifier: 'Chumper\\Zipper',
        package: 'chumper/zipper',
    },
    {
        identifier: 'Jose\\Component\\KeyManagement\\',
        package: 'web-token/jwt-key-mgmt',
    },
    {
        identifier: 'Localheinz\\Json\\Printer\\',
        package: 'localheinz/json-printer',
    },
    {
        identifier: 'Mimey\\',
        package: 'ralouphie/mimey',
    },
    {
        identifier: 'Mews\\Purifier',
        package: 'mews/purifier',
    },
    {
        identifier: 'TYPO3\\CMS\\Cli\\',
        package: 'typo3/cms-cli',
    },
    {
        identifier: 'Laracasts\\Utilities',
        package: 'laracasts/utilities',
    },
    {
        identifier: 'PhantomInstaller\\',
        package: 'jakoch/phantomjs-installer',
    },
    {
        identifier: 'Localheinz\\Json\\Normalizer\\',
        package: 'localheinz/json-normalizer',
    },
    {
        identifier: 'Swarrot',
        package: 'swarrot/swarrot',
    },
    {
        identifier: 'Liuggio\\ExcelBundle',
        package: 'liuggio/excelbundle',
    },
    {
        identifier: 'Cviebrock\\EloquentSluggable',
        package: 'cviebrock/eloquent-sluggable',
    },
    {
        identifier: 'League\\OAuth2\\Client\\',
        package: 'league/oauth2-google',
    },
    {
        identifier: 'Torann\\GeoIP',
        package: 'torann/geoip',
    },
    {
        identifier: 'mikemccabe\\JsonPatch\\',
        package: 'mikemccabe/json-patch-php',
    },
    {
        identifier: 'Geocoder\\Provider\\GoogleMaps\\',
        package: 'geocoder-php/google-maps-provider',
    },
    {
        identifier: 'Zend',
        package: 'zendframework/zendframework1',
    },
    {
        identifier: 'Localheinz\\Composer\\Normalize\\',
        package: 'localheinz/composer-normalize',
    },
    {
        identifier: 'Zend\\Memory\\',
        package: 'zendframework/zend-memory',
    },
    {
        identifier: 'Adyen\\',
        package: 'adyen/php-api-library',
    },
    {
        identifier: 'Zend\\Dom\\',
        package: 'zendframework/zend-dom',
    },
    {
        identifier: 'Env',
        package: 'oscarotero/env',
    },
    {
        identifier: 'fastImageSize\\',
        package: 'marc1706/fast-image-size',
    },
    {
        identifier: 'Infection\\',
        package: 'infection/infection',
    },
    {
        identifier: 'JMS\\TranslationBundle',
        package: 'jms/translation-bundle',
    },
    {
        identifier: 'Gregwar\\Captcha',
        package: 'gregwar/captcha',
    },
    {
        identifier: 'Symfony\\Component\\Panther\\',
        package: 'symfony/panther',
    },
    {
        identifier: 'Unirest',
        package: 'mashape/unirest-php',
    },
    {
        identifier: 'Localheinz\\Composer\\Json\\Normalizer\\',
        package: 'localheinz/composer-json-normalizer',
    },
    {
        identifier: 'Sonata\\EasyExtendsBundle',
        package: 'sonata-project/easy-extends-bundle',
    },
    {
        identifier: 'Zend\\Stratigility\\',
        package: 'zendframework/zend-stratigility',
    },
    {
        identifier: 'Symfony\\Component\\String\\',
        package: 'symfony/string',
    },
    {
        identifier: 'JMS\\SecurityExtraBundle',
        package: 'jms/security-extra-bundle',
    },
    {
        identifier: 'Cache\\Adapter\\PHPArray\\',
        package: 'cache/array-adapter',
    },
    {
        identifier: 'ScssPhp\\ScssPhp\\',
        package: 'scssphp/scssphp',
    },
    {
        identifier: 'Zizaco\\Entrust',
        package: 'zizaco/entrust',
    },
    {
        identifier: 'Gesdinet\\JWTRefreshTokenBundle\\',
        package: 'gesdinet/jwt-refresh-token-bundle',
    },
    {
        identifier: 'Umpirsky\\',
        package: 'umpirsky/twig-php-function',
    },
    {
        identifier: 'phpmock\\integration\\',
        package: 'php-mock/php-mock-integration',
    },
    {
        identifier: 'Swarrot\\SwarrotBundle\\',
        package: 'swarrot/swarrot-bundle',
    },
    {
        identifier: 'KnpU\\OAuth2ClientBundle\\',
        package: 'knpuniversity/oauth2-client-bundle',
    },
    {
        identifier: 'CommerceGuys\\Intl\\',
        package: 'commerceguys/intl',
    },
    {
        identifier: 'stringEncode',
        package: 'paquettg/string-encode',
    },
    {
        identifier: 'Zizaco\\FactoryMuff',
        package: 'league/factory-muffin',
    },
    {
        identifier: 'yii\\jui\\',
        package: 'yiisoft/yii2-jui',
    },
    {
        identifier: 'Illuminate\\Mail',
        package: 'illuminate/mail',
    },
    {
        identifier: 'Zend\\Permissions\\Rbac\\',
        package: 'zendframework/zend-permissions-rbac',
    },
    {
        identifier: 'App\\',
        package: 'phphleb/hleb',
    },
    {
        identifier: 'League\\Pipeline\\',
        package: 'league/pipeline',
    },
    {
        identifier: 'Zend\\Ldap\\',
        package: 'zendframework/zend-ldap',
    },
    {
        identifier: 'Kreait\\Clock\\',
        package: 'kreait/clock',
    },
    {
        identifier: 'Google\\Cloud\\PubSub\\',
        package: 'google/cloud-pubsub',
    },
    {
        identifier: 'InfluxDB\\',
        package: 'influxdb/influxdb-php',
    },
    {
        identifier: 'lsolesen\\pel\\',
        package: 'lsolesen/pel',
    },
    {
        identifier: 'Humbug\\SelfUpdate\\',
        package: 'padraic/phar-updater',
    },
    {
        identifier: 'Zend',
        package: 'zendframework/zendframework',
    },
    {
        identifier: 'Humbug\\',
        package: 'padraic/humbug_get_contents',
    },
    {
        identifier: 'Swaggest\\JsonDiff\\',
        package: 'swaggest/json-diff',
    },
    {
        identifier: 'Embed',
        package: 'embed/embed',
    },
    {
        identifier: 'cli',
        package: 'wp-cli/php-cli-tools',
    },
    {
        identifier: 'Mni\\FrontYAML\\',
        package: 'mnapoli/front-yaml',
    },
    {
        identifier: 'Zend\\HttpHandlerRunner\\',
        package: 'zendframework/zend-httphandlerrunner',
    },
    {
        identifier: 'Knp\\Bundle\\MarkdownBundle',
        package: 'knplabs/knp-markdown-bundle',
    },
    {
        identifier: 'Brick\\Math\\',
        package: 'brick/math',
    },
    {
        identifier: 'Zend\\Debug\\',
        package: 'zendframework/zend-debug',
    },
    {
        identifier: 'Coduo\\PHPMatcher',
        package: 'coduo/php-matcher',
    },
    {
        identifier: 'Mabe_',
        package: 'marc-mabe/php-enum',
    },
    {
        identifier: 'Fluent',
        package: 'fluent/logger',
    },
    {
        identifier: 'Renderer\\',
        package: 'slim/php-view',
    },
    {
        identifier: 'Tightenco\\Ziggy\\',
        package: 'tightenco/ziggy',
    },
    {
        identifier: 'League\\OAuth2\\Client\\',
        package: 'league/oauth2-facebook',
    },
    {
        identifier: 'TYPO3\\CMS\\Core\\',
        package: 'typo3/cms-core',
    },
    {
        identifier: 'Dflydev\\FigCookies\\',
        package: 'dflydev/fig-cookies',
    },
    {
        identifier: 'Net_URL2',
        package: 'pear/net_url2',
    },
    {
        identifier: 'GuzzleHttp\\Command\\',
        package: 'guzzlehttp/command',
    },
    {
        identifier: 'Enqueue\\AmqpLib\\',
        package: 'enqueue/amqp-lib',
    },
    {
        identifier: 'Ivory\\JsonBuilder',
        package: 'egeloen/json-builder',
    },
    {
        identifier: 'Payum\\ISO4217\\',
        package: 'payum/iso4217',
    },
    {
        identifier: 'Spatie\\Cors\\',
        package: 'spatie/laravel-cors',
    },
    {
        identifier: 'TYPO3\\CMS\\Frontend\\',
        package: 'typo3/cms-frontend',
    },
    {
        identifier: 'TYPO3\\CMS\\Extbase\\',
        package: 'typo3/cms-extbase',
    },
    {
        identifier: 'Csa\\Bundle\\GuzzleBundle\\',
        package: 'csa/guzzle-bundle',
    },
    {
        identifier: 'TYPO3\\CMS\\Backend\\',
        package: 'typo3/cms-backend',
    },
    {
        identifier: 'phpDocumentor_GraphViz_',
        package: 'phpdocumentor/graphviz',
    },
    {
        identifier: 'GuzzleHttp\\Command\\Guzzle\\',
        package: 'guzzlehttp/guzzle-services',
    },
    {
        identifier: 'React\\ChildProcess\\',
        package: 'react/child-process',
    },
    {
        identifier: 'TYPO3\\CMS\\Fluid\\',
        package: 'typo3/cms-fluid',
    },
    {
        identifier: 'BenSampo\\Enum\\',
        package: 'bensampo/laravel-enum',
    },
    {
        identifier: 'TYPO3\\CMS\\Recordlist\\',
        package: 'typo3/cms-recordlist',
    },
    {
        identifier: 'Mdanter\\Ecc\\Tests\\',
        package: 'mdanter/ecc',
    },
    {
        identifier: 'voku',
        package: 'voku/anti-xss',
    },
    {
        identifier: 'enshrined\\svgSanitize\\',
        package: 'enshrined/svg-sanitize',
    },
    {
        identifier: 'Nwidart\\Modules\\',
        package: 'nwidart/laravel-modules',
    },
    {
        identifier: 'Google\\Cloud\\BigQuery\\',
        package: 'google/cloud-bigquery',
    },
    {
        identifier: 'Windwalker\\Registry\\',
        package: 'windwalker/structure',
    },
    {
        identifier: 'SimplePie',
        package: 'simplepie/simplepie',
    },
    {
        identifier: 'Windwalker\\Renderer\\',
        package: 'windwalker/renderer',
    },
    {
        identifier: 'Syslogic\\DoctrineJsonFunctions\\',
        package: 'scienta/doctrine-json-functions',
    },
    {
        identifier: 'DoctrineModule',
        package: 'doctrine/doctrine-module',
    },
    {
        identifier: 'TYPO3\\CMS\\Install\\',
        package: 'typo3/cms-install',
    },
    {
        identifier: 'React\\Http',
        package: 'react/http',
    },
    {
        identifier: 'Zend\\Test\\',
        package: 'zendframework/zend-test',
    },
    {
        identifier: 'Xethron\\MigrationsGenerator',
        package: 'xethron/migrations-generator',
    },
    {
        identifier: 'AESGCM\\',
        package: 'spomky-labs/php-aes-gcm',
    },
    {
        identifier: 'SM',
        package: 'winzou/state-machine',
    },
    {
        identifier: 'SqlParser\\',
        package: 'phpmyadmin/sql-parser',
    },
    {
        identifier: 'SunCat\\MobileDetectBundle',
        package: 'suncat/mobile-detect-bundle',
    },
    {
        identifier: 'Vinkla\\Hashids\\',
        package: 'vinkla/hashids',
    },
    {
        identifier: 'Google\\Cloud\\Logging\\',
        package: 'google/cloud-logging',
    },
    {
        identifier: 'Codedungeon\\PHPCliColor\\',
        package: 'codedungeon/php-cli-colors',
    },
    {
        identifier: 'Mcamara\\LaravelLocalization',
        package: 'mcamara/laravel-localization',
    },
    {
        identifier: 'Spatie\\Translatable\\',
        package: 'spatie/laravel-translatable',
    },
    {
        identifier: 'TYPO3\\CMS\\Extensionmanager\\',
        package: 'typo3/cms-extensionmanager',
    },
    {
        identifier: 'Way\\Generators',
        package: 'xethron/laravel-4-generators',
    },
    {
        identifier: 'Zend\\XmlRpc\\',
        package: 'zendframework/zend-xmlrpc',
    },
    {
        identifier: 'hybridauth',
        package: 'hybridauth/hybridauth',
    },
    {
        identifier: 'Boris',
        package: 'd11wtq/boris',
    },
    {
        identifier: 'Goodby\\CSV',
        package: 'goodby/csv',
    },
    {
        identifier: 'FriendsOfBehat\\SymfonyExtension\\',
        package: 'friends-of-behat/symfony-extension',
    },
    {
        identifier: 'kartik\\',
        package: 'kartik-v/bootstrap-fileinput',
    },
    {
        identifier: 'Github',
        package: 'knplabs/github-api',
    },
    {
        identifier: 'PHPStan\\',
        package: 'phpstan/phpstan-webmozart-assert',
    },
    {
        identifier: 'Spatie\\Crawler\\',
        package: 'spatie/crawler',
    },
    {
        identifier: 'hanneskod\\classtools\\',
        package: 'hanneskod/classtools',
    },
    {
        identifier: 'MicrosoftAzure\\Storage\\Common\\',
        package: 'microsoft/azure-storage-common',
    },
    {
        identifier: 'Opis\\JsonSchema\\',
        package: 'opis/json-schema',
    },
    {
        identifier: 'Scheb\\TwoFactorBundle\\',
        package: 'scheb/two-factor-bundle',
    },
    {
        identifier: 'Zend\\Navigation\\',
        package: 'zendframework/zend-navigation',
    },
    {
        identifier: 'JanGregor\\Prophecy\\',
        package: 'jangregor/phpstan-prophecy',
    },
    {
        identifier: 'Overtrue\\PHPLint\\',
        package: 'overtrue/phplint',
    },
    {
        identifier: 'Punic\\',
        package: 'punic/punic',
    },
    {
        identifier: 'Mailjet',
        package: 'mailjet/mailjet-apiv3-php',
    },
    {
        identifier: 'Sunra\\PhpSimple\\HtmlDomParser',
        package: 'paquettg/php-html-parser',
    },
    {
        identifier: 'Mpociot\\Documentarian\\',
        package: 'mpociot/documentarian',
    },
    {
        identifier: 'JsonStreamingParser',
        package: 'salsify/json-streaming-parser',
    },
    {
        identifier: 'Helhum\\Typo3Console\\',
        package: 'helhum/typo3-console',
    },
    {
        identifier: 'Resque',
        package: 'chrisboulton/php-resque',
    },
    {
        identifier: 'Intervention\\Image',
        package: 'intervention/imagecache',
    },
    {
        identifier: 'Helhum\\Typo3ConsolePlugin\\',
        package: 'helhum/typo3-console-plugin',
    },
    {
        identifier: 'Spatie\\Macroable\\',
        package: 'spatie/macroable',
    },
    {
        identifier: 'Gos\\Component\\WebSocketClient\\',
        package: 'gos/websocket-client',
    },
    {
        identifier: 'Gos\\Bundle\\WebSocketBundle\\',
        package: 'gos/web-socket-bundle',
    },
    {
        identifier: 'Http\\Mock\\',
        package: 'php-http/mock-client',
    },
    {
        identifier: 'Knp\\Bundle\\TimeBundle',
        package: 'knplabs/knp-time-bundle',
    },
    {
        identifier: 'Gos\\Bundle\\PubSubRouterBundle\\',
        package: 'gos/pubsub-router-bundle',
    },
    {
        identifier: 'Exercise\\HTMLPurifierBundle',
        package: 'exercise/htmlpurifier-bundle',
    },
    {
        identifier: 'TYPO3\\CMS\\Filelist\\',
        package: 'typo3/cms-filelist',
    },
    {
        identifier: 'GeoJson\\',
        package: 'jmikola/geojson',
    },
    {
        identifier: 'phpmock\\phpunit\\',
        package: 'php-mock/php-mock-phpunit',
    },
    {
        identifier: 'Maxbanton\\Cwh\\',
        package: 'maxbanton/cwh',
    },
    {
        identifier: 'Venturecraft\\Revisionable',
        package: 'venturecraft/revisionable',
    },
    {
        identifier: 'Kalnoy\\Nestedset',
        package: 'kalnoy/nestedset',
    },
    {
        identifier: 'EWZ\\Bundle\\RecaptchaBundle\\',
        package: 'excelwebzone/recaptcha-bundle',
    },
    {
        identifier: 'DoctrineORMModule',
        package: 'doctrine/doctrine-orm-module',
    },
    {
        identifier: 'Spatie\\EloquentSortable\\',
        package: 'spatie/eloquent-sortable',
    },
    {
        identifier: 'Zend\\Expressive\\Router\\',
        package: 'zendframework/zend-expressive-router',
    },
    {
        identifier: 'Illuminate\\Routing',
        package: 'illuminate/routing',
    },
    {
        identifier: 'Peekmo\\JsonPath',
        package: 'peekmo/jsonpath',
    },
    {
        identifier: 'itbz\\libmergepdf',
        package: 'iio/libmergepdf',
    },
    {
        identifier: 'phpDocumentor',
        package: 'mpociot/reflection-docblock',
    },
    {
        identifier: 'Endroid\\Installer\\',
        package: 'endroid/installer',
    },
    {
        identifier: 'MicrosoftAzure\\Storage\\Blob\\',
        package: 'microsoft/azure-storage-blob',
    },
    {
        identifier: 'JsonPointer',
        package: 'php-jsonpointer/php-jsonpointer',
    },
    {
        identifier: 'Bramus\\Ansi\\',
        package: 'bramus/ansi-php',
    },
    {
        identifier: 'Zend\\ComponentInstaller\\',
        package: 'zendframework/zend-component-installer',
    },
    {
        identifier: 'LaravelFCM\\',
        package: 'brozot/laravel-fcm',
    },
    {
        identifier: 'Superbalist\\LaravelGoogleCloudStorage\\',
        package: 'superbalist/laravel-google-cloud-storage',
    },
    {
        identifier: 'Socket',
        package: 'clue/socket-raw',
    },
    {
        identifier: 'Codeception\\c3\\',
        package: 'codeception/c3',
    },
    {
        identifier: 'TYPO3\\CMS\\RteCKEditor\\',
        package: 'typo3/cms-rte-ckeditor',
    },
    {
        identifier: 'Umpirsky\\Country',
        package: 'umpirsky/country-list',
    },
    {
        identifier: 'PragmaRX\\Google2FALaravel\\',
        package: 'pragmarx/google2fa-laravel',
    },
    {
        identifier: 'TYPO3\\CMS\\Tstemplate\\',
        package: 'typo3/cms-tstemplate',
    },
    {
        identifier: 'Slim\\Views\\',
        package: 'slim/twig-view',
    },
    {
        identifier: 'Smtpapi',
        package: 'sendgrid/smtpapi',
    },
    {
        identifier: 'Presta\\SitemapBundle\\',
        package: 'presta/sitemap-bundle',
    },
    {
        identifier: 'Swaggest\\JsonSchema\\',
        package: 'swaggest/json-schema',
    },
    {
        identifier: 'Clue\\React\\Buzz\\',
        package: 'clue/buzz-react',
    },
    {
        identifier: 'ZendService',
        package: 'zendframework/zendservice-apple-apns',
    },
    {
        identifier: 'Mpociot\\ApiDoc',
        package: 'mpociot/laravel-apidoc-generator',
    },
    {
        identifier: 'kartik\\',
        package: 'kartik-v/yii2-grid',
    },
    {
        identifier: 'Anhskohbo\\NoCaptcha\\',
        package: 'anhskohbo/no-captcha',
    },
    {
        identifier: 'SimpleBus\\Message\\',
        package: 'simple-bus/message-bus',
    },
    {
        identifier: 'kartik\\form\\',
        package: 'kartik-v/yii2-widget-activeform',
    },
    {
        identifier: 'Colors',
        package: 'kevinlebrun/colors.php',
    },
    {
        identifier: 'Lab404\\Impersonate\\',
        package: 'lab404/laravel-impersonate',
    },
    {
        identifier: 'Orangehill\\Iseed',
        package: 'orangehill/iseed',
    },
    {
        identifier: 'Zend\\File\\',
        package: 'zendframework/zend-file',
    },
    {
        identifier: 'LightSaml\\Tests\\',
        package: 'lightsaml/lightsaml',
    },
    {
        identifier: 'Ivory\\CKEditorBundle',
        package: 'egeloen/ckeditor-bundle',
    },
    {
        identifier: 'Fxp\\Composer\\AssetPlugin\\',
        package: 'fxp/composer-asset-plugin',
    },
    {
        identifier: 'League\\Tactician\\Bundle\\',
        package: 'league/tactician-bundle',
    },
    {
        identifier: 'Gos\\Component\\PnctlEventLoopEmitter\\',
        package: 'gos/pnctl-event-loop-emitter',
    },
    {
        identifier: 'EmailReplyParser',
        package: 'willdurand/email-reply-parser',
    },
    {
        identifier: 'Google\\Cloud\\Translate\\',
        package: 'google/cloud-translate',
    },
    {
        identifier: 'kartik\\datetime\\',
        package: 'kartik-v/yii2-widget-datetimepicker',
    },
    {
        identifier: 'TYPO3\\CMS\\Scheduler\\',
        package: 'typo3/cms-scheduler',
    },
    {
        identifier: 'voku\\',
        package: 'voku/portable-ascii',
    },
    {
        identifier: 'PHPStan\\',
        package: 'mglaman/phpstan-drupal',
    },
    {
        identifier: 'Zend\\Expressive\\Helper\\',
        package: 'zendframework/zend-expressive-helpers',
    },
    {
        identifier: 'SpomkyLabs\\Jose\\',
        package: 'spomky-labs/jose',
    },
    {
        identifier: 'kartik\\date\\',
        package: 'kartik-v/yii2-widget-datepicker',
    },
    {
        identifier: 'PhpLang\\',
        package: 'phplang/scope-exit',
    },
    {
        identifier: 'ERP\\Swagger\\',
        package: 'epfremme/swagger-php',
    },
    {
        identifier: 'LitEmoji\\',
        package: 'elvanto/litemoji',
    },
    {
        identifier: 'bramus\\monolog\\',
        package: 'bramus/monolog-colored-line-formatter',
    },
    {
        identifier: 'App\\',
        package: 'symfony/website-skeleton',
    },
    {
        identifier: 'Helhum\\ConfigLoader\\',
        package: 'helhum/config-loader',
    },
    {
        identifier: 'SensioLabs\\AnsiConverter',
        package: 'sensiolabs/ansi-to-html',
    },
    {
        identifier: 'TYPO3\\CMS\\Info\\',
        package: 'typo3/cms-info',
    },
    {
        identifier: 'creocoder\\nestedsets\\',
        package: 'creocoder/yii2-nested-sets',
    },
    {
        identifier: 'Symfony\\Component\\Ldap\\',
        package: 'symfony/ldap',
    },
    {
        identifier: 'Laracasts\\Generators\\',
        package: 'laracasts/generators',
    },
    {
        identifier: 'OSS\\',
        package: 'aliyuncs/oss-sdk-php',
    },
    {
        identifier: 'League\\FactoryMuffin\\Faker\\',
        package: 'league/factory-muffin-faker',
    },
    {
        identifier: 'NunoMaduro\\PhpInsights\\',
        package: 'nunomaduro/phpinsights',
    },
    {
        identifier: 'kartik\\file\\',
        package: 'kartik-v/yii2-widget-fileinput',
    },
    {
        identifier: 'TYPO3\\CMS\\Beuser\\',
        package: 'typo3/cms-beuser',
    },
    {
        identifier: 'Mailchimp',
        package: 'mailchimp/mailchimp',
    },
    {
        identifier: 'Yajra\\Datatables\\',
        package: 'yajra/laravel-datatables-html',
    },
    {
        identifier: 'League\\Tactician\\Container\\',
        package: 'league/tactician-container',
    },
    {
        identifier: 'TYPO3\\CMS\\FluidStyledContent\\',
        package: 'typo3/cms-fluid-styled-content',
    },
    {
        identifier: 'Minishlink\\WebPush\\',
        package: 'minishlink/web-push',
    },
    {
        identifier: 'RandomLib',
        package: 'paragonie/random-lib',
    },
    {
        identifier: 'Spatie\\Sitemap\\',
        package: 'spatie/laravel-sitemap',
    },
    {
        identifier: 'Arcanedev\\Support\\',
        package: 'arcanedev/support',
    },
    {
        identifier: 'winzou\\Bundle\\StateMachineBundle\\',
        package: 'winzou/state-machine-bundle',
    },
    {
        identifier: 'Spatie\\QueryBuilder\\',
        package: 'spatie/laravel-query-builder',
    },
    {
        identifier: 'Payum\\Bundle\\PayumBundle',
        package: 'payum/payum-bundle',
    },
    {
        identifier: 'Csa\\GuzzleHttp\\Middleware\\Cache\\',
        package: 'csa/guzzle-cache-middleware',
    },
    {
        identifier: 'Csa\\GuzzleHttp\\Middleware\\History\\',
        package: 'csa/guzzle-history-middleware',
    },
    {
        identifier: 'Symfony\\Component\\Notifier\\',
        package: 'symfony/notifier',
    },
    {
        identifier: 'Csa\\GuzzleHttp\\Middleware\\Stopwatch\\',
        package: 'csa/guzzle-stopwatch-middleware',
    },
    {
        identifier: 'Spatie\\Robots\\',
        package: 'spatie/robots-txt',
    },
    {
        identifier: 'BeSimple\\SoapCommon',
        package: 'besimple/soap-common',
    },
    {
        identifier: 'TYPO3\\CMS\\Setup\\',
        package: 'typo3/cms-setup',
    },
    {
        identifier: 'ChromePhp',
        package: 'ccampbell/chromephp',
    },
    {
        identifier: 'mikehaertl\\pdftk\\',
        package: 'mikehaertl/php-pdftk',
    },
    {
        identifier: 'Symfony\\Bundle\\AclBundle\\',
        package: 'symfony/acl-bundle',
    },
    {
        identifier: 'Nyholm\\',
        package: 'nyholm/nsa',
    },
    {
        identifier: 'kartik\\dialog\\',
        package: 'kartik-v/yii2-dialog',
    },
    {
        identifier: 'TYPO3\\CMS\\Belog\\',
        package: 'typo3/cms-belog',
    },
    {
        identifier: 'MessageBird\\',
        package: 'messagebird/php-rest-api',
    },
    {
        identifier: 'Postmark\\',
        package: 'wildbit/postmark-php',
    },
    {
        identifier: 'Exchanger\\',
        package: 'florianv/exchanger',
    },
    {
        identifier: 'ResqueScheduler',
        package: 'chrisboulton/php-resque-scheduler',
    },
    {
        identifier: 'Desarrolla2\\Cache\\',
        package: 'desarrolla2/cache',
    },
    {
        identifier: 'LayerShifter\\TLDDatabase\\',
        package: 'layershifter/tld-database',
    },
    {
        identifier: 'GrahamCampbell\\Markdown',
        package: 'graham-campbell/markdown',
    },
    {
        identifier: 'Dusterio\\AwsWorker\\',
        package: 'dusterio/laravel-aws-worker',
    },
    {
        identifier: 'BeSimple\\SoapClient',
        package: 'besimple/soap-client',
    },
    {
        identifier: 'LayerShifter\\TLDSupport\\',
        package: 'layershifter/tld-support',
    },
    {
        identifier: 'Gregwar\\Image',
        package: 'gregwar/image',
    },
    {
        identifier: 'LayerShifter\\TLDExtract\\',
        package: 'layershifter/tld-extract',
    },
    {
        identifier: 'WP_CLI',
        package: 'wp-cli/wp-cli',
    },
    {
        identifier: 'RobRichards\\WsePhp\\',
        package: 'robrichards/wse-php',
    },
    {
        identifier: 'JMS\\I18nRoutingBundle',
        package: 'jms/i18n-routing-bundle',
    },
    {
        identifier: 'Endroid',
        package: 'endroid/qrcode',
    },
    {
        identifier: 'Omnipay\\PayPal\\',
        package: 'omnipay/paypal',
    },
    {
        identifier: 'Milon\\Barcode',
        package: 'milon/barcode',
    },
    {
        identifier: 'PhpUnitsOfMeasure',
        package: 'php-units-of-measure/php-units-of-measure',
    },
    {
        identifier: 'League\\Flysystem\\ZipArchive\\',
        package: 'league/flysystem-ziparchive',
    },
    {
        identifier: 'Spatie\\SchemaOrg\\',
        package: 'spatie/schema-org',
    },
    {
        identifier: 'Fungku\\HubSpot\\',
        package: 'ryanwinchester/hubspot-php',
    },
    {
        identifier: 'ZendService',
        package: 'zendframework/zendservice-google-gcm',
    },
    {
        identifier: 'Stash',
        package: 'tedivm/stash',
    },
    {
        identifier: 'TYPO3\\CMS\\Form\\',
        package: 'typo3/cms-form',
    },
    {
        identifier: 'Creativeorange\\Gravatar',
        package: 'creativeorange/gravatar',
    },
    {
        identifier: 'Herrera\\Json',
        package: 'herrera-io/json',
    },
    {
        identifier: 'Jenssegers\\Rollbar\\',
        package: 'rollbar/rollbar-laravel',
    },
    {
        identifier: 'Arcanedev\\LogViewer\\',
        package: 'arcanedev/log-viewer',
    },
    {
        identifier: 'Overtrue\\Socialite\\',
        package: 'overtrue/socialite',
    },
    {
        identifier: 'kartik\\mpdf\\',
        package: 'kartik-v/yii2-mpdf',
    },
    {
        identifier: 'Recurr',
        package: 'simshaun/recurr',
    },
    {
        identifier: 'TYPO3\\CMS\\Seo\\',
        package: 'typo3/cms-seo',
    },
    {
        identifier: 'Acquia\\LightningExtension\\',
        package: 'acquia/lightning',
    },
    {
        identifier: 'bantu\\IniGetWrapper\\',
        package: 'bantu/ini-get-wrapper',
    },
    {
        identifier: 'Dissect',
        package: 'jakubledl/dissect',
    },
    {
        identifier: 'Icewind\\Streams\\Tests\\',
        package: 'icewind/streams',
    },
    {
        identifier: 'Herrera\\Phar\\Update',
        package: 'herrera-io/phar-update',
    },
    {
        identifier: 'Location',
        package: 'mjaschen/phpgeo',
    },
    {
        identifier: 'Arrilot\\Widgets\\',
        package: 'arrilot/laravel-widgets',
    },
    {
        identifier: 'Fresh\\Bundle\\DoctrineEnumBundle',
        package: 'fresh/doctrine-enum-bundle',
    },
    {
        identifier: 'Zend\\ProgressBar\\',
        package: 'zendframework/zend-progressbar',
    },
    {
        identifier: 'Go',
        package: 'goaop/framework',
    },
    {
        identifier: 'PSS\\SymfonyMockerContainer',
        package: 'polishsymfonycommunity/symfony-mocker-container',
    },
    {
        identifier: 'Litipk\\BigNumbers',
        package: 'litipk/php-bignumbers',
    },
    {
        identifier: 'Bakyt\\',
        package: '2bj/phanybar',
    },
    {
        identifier: 'DDTrace\\',
        package: 'datadog/dd-trace',
    },
    {
        identifier: 'ZxcvbnPhp',
        package: 'bjeavons/zxcvbn-php',
    },
    {
        identifier: 'Swap',
        package: 'florianv/swap',
    },
    {
        identifier: 'TYPO3\\CMS\\Reports\\',
        package: 'typo3/cms-reports',
    },
    {
        identifier: 'yii\\authclient\\',
        package: 'yiisoft/yii2-authclient',
    },
    {
        identifier: 'rdx\\behatvars\\',
        package: 'rdx/behat-variables',
    },
    {
        identifier: 'Enqueue\\Sqs\\',
        package: 'enqueue/sqs',
    },
    {
        identifier: 'ParagonIE\\Halite\\',
        package: 'paragonie/halite',
    },
    {
        identifier: 'Imgix\\',
        package: 'imgix/imgix-php',
    },
    {
        identifier: 'yii2tech\\ar\\softdelete\\',
        package: 'yii2tech/ar-softdelete',
    },
    {
        identifier: 'FintechFab\\LaravelQueueRabbitMQ',
        package: 'vladimir-yuldashev/laravel-queue-rabbitmq',
    },
    {
        identifier: 'Mail',
        package: 'pear/mail_mime',
    },
    {
        identifier: 'Overblog\\GraphQLBundle\\',
        package: 'overblog/graphql-bundle',
    },
    {
        identifier: 'Acquia\\Hmac\\',
        package: 'acquia/http-hmac-php',
    },
    {
        identifier: 'Yajra\\Datatables\\',
        package: 'yajra/laravel-datatables-buttons',
    },
    {
        identifier: 'League\\Tactician\\Logger\\',
        package: 'league/tactician-logger',
    },
    {
        identifier: 'Translation\\Extractor\\',
        package: 'php-translation/extractor',
    },
    {
        identifier: 'A2lix\\TranslationFormBundle',
        package: 'a2lix/translation-form-bundle',
    },
    {
        identifier: 'Microsoft\\Graph\\',
        package: 'microsoft/microsoft-graph',
    },
    {
        identifier: 'chillerlan\\QRCode\\',
        package: 'chillerlan/php-qrcode',
    },
    {
        identifier: 'Curl',
        package: 'curl/curl',
    },
    {
        identifier: 'Translation\\SymfonyStorage\\',
        package: 'php-translation/symfony-storage',
    },
    {
        identifier: 'Translation\\Common\\',
        package: 'php-translation/common',
    },
    {
        identifier: 'grasmash\\DrupalSecurityWarning\\',
        package: 'grasmash/drupal-security-warning',
    },
    {
        identifier: 'Mageplaza\\Smtp\\',
        package: 'mageplaza/module-smtp',
    },
    {
        identifier: 'TYPO3\\CMS\\Lowlevel\\',
        package: 'typo3/cms-lowlevel',
    },
    {
        identifier: 'PragmaRX\\Google2FAQRCode\\',
        package: 'pragmarx/google2fa-qrcode',
    },
    {
        identifier: 'Sonata\\UserBundle',
        package: 'sonata-project/user-bundle',
    },
    {
        identifier: 'BrainMaestro\\GitHooks\\',
        package: 'brainmaestro/composer-git-hooks',
    },
    {
        identifier: 'Zend\\Expressive\\Template\\',
        package: 'zendframework/zend-expressive-template',
    },
    {
        identifier: 'Enqueue\\MessengerAdapter\\',
        package: 'sroze/messenger-enqueue-transport',
    },
    {
        identifier: 'TYPO3\\CMS\\Viewpage\\',
        package: 'typo3/cms-viewpage',
    },
    {
        identifier: 'Omnipay',
        package: 'league/omnipay',
    },
    {
        identifier: 'AcquiaCloudApi\\CloudApi\\',
        package: 'typhonius/acquia-php-sdk-v2',
    },
    {
        identifier: 'Yasumi\\',
        package: 'azuyalabs/yasumi',
    },
    {
        identifier: 'malkusch\\lock\\',
        package: 'malkusch/lock',
    },
    {
        identifier: 'Amp\\Parser\\',
        package: 'amphp/parser',
    },
    {
        identifier: 'Twig\\Extra\\Intl\\',
        package: 'twig/intl-extra',
    },
    {
        identifier: 'SimpleBus\\SymfonyBridge\\',
        package: 'simple-bus/symfony-bridge',
    },
    {
        identifier: 'Overtrue\\',
        package: 'overtrue/wechat',
    },
    {
        identifier: 'Geocoder\\Provider\\Chain\\',
        package: 'geocoder-php/chain-provider',
    },
    {
        identifier: 'Codeception\\Module\\',
        package: 'codeception/mockery-module',
    },
    {
        identifier: 'Zend\\Version\\',
        package: 'zendframework/zend-version',
    },
    {
        identifier: 'johnpbloch\\Composer\\',
        package: 'roots/wordpress-core-installer',
    },
    {
        identifier: 'Zend\\ConfigAggregator\\',
        package: 'zendframework/zend-config-aggregator',
    },
    {
        identifier: 'Crell\\ApiProblem',
        package: 'crell/api-problem',
    },
    {
        identifier: 'Grasmash\\YamlCli\\',
        package: 'grasmash/yaml-cli',
    },
    {
        identifier: 'Watson\\Rememberable\\',
        package: 'watson/rememberable',
    },
    {
        identifier: 'OpenTracing\\',
        package: 'opentracing/opentracing',
    },
    {
        identifier: 'Zend\\Tag\\',
        package: 'zendframework/zend-tag',
    },
    {
        identifier: 'Bab\\RabbitMq',
        package: 'odolbeau/rabbit-mq-admin-toolkit',
    },
    {
        identifier: 'Zend\\Expressive\\',
        package: 'zendframework/zend-expressive',
    },
    {
        identifier: 'Guzzle\\Parser',
        package: 'guzzle/parser',
    },
    {
        identifier: 'yii\\imagine\\',
        package: 'yiisoft/yii2-imagine',
    },
    {
        identifier: 'React\\SocketClient',
        package: 'react/socket-client',
    },
    {
        identifier: 'Vimeo\\',
        package: 'vimeo/vimeo-api',
    },
    {
        identifier: 'Google\\Cloud\\ErrorReporting\\',
        package: 'google/cloud-error-reporting',
    },
    {
        identifier: 'Spatie\\Snapshots\\',
        package: 'spatie/phpunit-snapshot-assertions',
    },
    {
        identifier: 'Hautelook',
        package: 'hautelook/phpass',
    },
    {
        identifier: 'Spatie\\Sluggable\\',
        package: 'spatie/laravel-sluggable',
    },
    {
        identifier: 'Go\\ParserReflection\\',
        package: 'goaop/parser-reflection',
    },
    {
        identifier: 'Symfony\\Component\\Mercure\\',
        package: 'symfony/mercure',
    },
    {
        identifier: 'Translation\\Bundle\\',
        package: 'php-translation/symfony-bundle',
    },
    {
        identifier: 'Consolidation\\Comments\\',
        package: 'consolidation/comments',
    },
    {
        identifier: 'Sylius\\Component\\Registry\\',
        package: 'sylius/registry',
    },
    {
        identifier: 'Lullabot\\AMP\\',
        package: 'lullabot/amp',
    },
    {
        identifier: 'TYPO3\\CMS\\Felogin\\',
        package: 'typo3/cms-felogin',
    },
    {
        identifier: 'Enqueue\\AsyncEventDispatcher\\',
        package: 'enqueue/async-event-dispatcher',
    },
    {
        identifier: 'Guzzle\\Common',
        package: 'guzzle/common',
    },
    {
        identifier: 'Amp\\Sync\\',
        package: 'amphp/sync',
    },
    {
        identifier: 'ParagonIE\\HiddenString\\',
        package: 'paragonie/hidden-string',
    },
    {
        identifier: 'HTTP_Request2',
        package: 'pear/http_request2',
    },
    {
        identifier: 'Guzzle\\Stream',
        package: 'guzzle/stream',
    },
    {
        identifier: 'Guzzle\\Http',
        package: 'guzzle/http',
    },
    {
        identifier: 'phpDocumentor',
        package: 'phpdocumentor/reflection',
    },
    {
        identifier: 'AdBar\\',
        package: 'adbario/php-dot-notation',
    },
    {
        identifier: 'BetterReflection\\',
        package: 'roave/better-reflection',
    },
    {
        identifier: 'craftcms\\oauth2\\client\\',
        package: 'craftcms/oauth2-craftid',
    },
    {
        identifier: 'DeepDiver1975\\TarStreamer\\',
        package: 'deepdiver1975/tarstreamer',
    },
    {
        identifier: 'TYPO3\\CMS\\Redirects\\',
        package: 'typo3/cms-redirects',
    },
    {
        identifier: 'InterfaSys\\LogNormalizer\\',
        package: 'interfasys/lognormalizer',
    },
    {
        identifier: 'ID3Parser\\',
        package: 'lukasreschke/id3parser',
    },
    {
        identifier: 'Tinify\\',
        package: 'tinify/tinify',
    },
    {
        identifier: 'TwigBridge',
        package: 'rcrowe/twigbridge',
    },
    {
        identifier: 'Roave\\Signature\\',
        package: 'roave/signature',
    },
    {
        identifier: 'Sichikawa\\LaravelSendgridDriver\\',
        package: 's-ichikawa/laravel-sendgrid-driver',
    },
    {
        identifier: 'vierbergenlars\\SemVer',
        package: 'vierbergenlars/php-semver',
    },
    {
        identifier: 'Bunny\\',
        package: 'bunny/bunny',
    },
    {
        identifier: 'Oneup\\UploaderBundle',
        package: 'oneup/uploader-bundle',
    },
    {
        identifier: 'Symfony\\Bundle\\MercureBundle\\',
        package: 'symfony/mercure-bundle',
    },
    {
        identifier: 'Ds\\',
        package: 'php-ds/php-ds',
    },
    {
        identifier: 'ConsoleTVs\\Charts\\',
        package: 'consoletvs/charts',
    },
    {
        identifier: 'OC\\CodingStandard\\',
        package: 'owncloud/coding-standard',
    },
    {
        identifier: 'FXMLRPC',
        package: 'lstrojny/fxmlrpc',
    },
    {
        identifier: 'ZF\\ApiProblem\\',
        package: 'zfcampus/zf-api-problem',
    },
    {
        identifier: 'Roots\\WPConfig\\',
        package: 'roots/wp-config',
    },
    {
        identifier: 'Fhaculty',
        package: 'clue/graph',
    },
    {
        identifier: 'Omnipay\\PaymentExpress\\',
        package: 'omnipay/paymentexpress',
    },
    {
        identifier: 'Contrib\\Component',
        package: 'php-coveralls/php-coveralls',
    },
    {
        identifier: 'Liuggio\\Fastest\\',
        package: 'liuggio/fastest',
    },
    {
        identifier: 'Ratchet\\Client\\',
        package: 'ratchet/pawl',
    },
    {
        identifier: 'FacebookAds\\',
        package: 'facebook/php-business-sdk',
    },
    {
        identifier: 'League\\FlysystemBundle\\',
        package: 'league/flysystem-bundle',
    },
    {
        identifier: 'Contrib\\Component',
        package: 'satooshi/php-coveralls',
    },
    {
        identifier: 'Gregwar\\CaptchaBundle',
        package: 'gregwar/captcha-bundle',
    },
    {
        identifier: 'GraphQL\\',
        package: 'gmostafa/php-graphql-client',
    },
    {
        identifier: 'Oxymel',
        package: 'nb/oxymel',
    },
    {
        identifier: 'Matthias\\SymfonyConfigTest',
        package: 'matthiasnoback/symfony-config-test',
    },
    {
        identifier: 'PHPStan\\',
        package: 'mglaman/phpstan-junit',
    },
    {
        identifier: 'AspectMock',
        package: 'codeception/aspect-mock',
    },
    {
        identifier: 'xrstf\\Composer52',
        package: 'xrstf/composer-php52',
    },
    {
        identifier: 'Fico7489\\Laravel\\Pivot\\',
        package: 'fico7489/laravel-pivot',
    },
    {
        identifier: 'kartik\\',
        package: 'kartik-v/dependent-dropdown',
    },
    {
        identifier: 'FileEye\\MimeMap\\',
        package: 'fileeye/mimemap',
    },
    {
        identifier: 'craft\\composer\\',
        package: 'craftcms/plugin-installer',
    },
    {
        identifier: 'Psr\\Http\\Middleware\\',
        package: 'http-interop/http-middleware',
    },
    {
        identifier: 'ZendDeveloperTools',
        package: 'zendframework/zend-developer-tools',
    },
    {
        identifier: 'App\\',
        package: 'symfony/skeleton',
    },
    {
        identifier: 'Stringy',
        package: 'voku/arrayy',
    },
    {
        identifier: 'PackageVersions\\',
        package: 'muglug/package-versions-56',
    },
    {
        identifier: 'Spatie\\LaravelAnalytics\\',
        package: 'spatie/laravel-analytics',
    },
    {
        identifier: 'Ixudra\\Curl\\',
        package: 'ixudra/curl',
    },
    {
        identifier: 'kartik\\depdrop\\',
        package: 'kartik-v/yii2-widget-depdrop',
    },
    {
        identifier: 'Rollerworks\\Component\\PasswordStrength\\',
        package: 'rollerworks/password-strength-validator',
    },
    {
        identifier: 'Zend\\Mvc\\Console\\',
        package: 'zendframework/zend-mvc-console',
    },
    {
        identifier: 'Tivie\\OS\\',
        package: 'tivie/php-os-detector',
    },
    {
        identifier: 'Shaper\\',
        package: 'e0ipso/shaper',
    },
    {
        identifier: 'Spatie\\Newsletter\\',
        package: 'spatie/laravel-newsletter',
    },
    {
        identifier: 'GeoIO\\',
        package: 'geo-io/interface',
    },
    {
        identifier: 'Valitron',
        package: 'vlucas/valitron',
    },
    {
        identifier: 'DrupalCheck\\',
        package: 'mglaman/drupal-check',
    },
    {
        identifier: 'kartik\\time\\',
        package: 'kartik-v/yii2-widget-timepicker',
    },
    {
        identifier: 'JSMin\\',
        package: 'mrclay/jsmin-php',
    },
    {
        identifier: 'kartik\\color\\',
        package: 'kartik-v/yii2-widget-colorinput',
    },
    {
        identifier: 'dflydev\\markdown',
        package: 'dflydev/markdown',
    },
    {
        identifier: 'ComposerRequireChecker\\',
        package: 'maglnet/composer-require-checker',
    },
    {
        identifier: 'Sly',
        package: 'sly/notification-pusher',
    },
    {
        identifier: 'TYPO3\\CMS\\T3editor\\',
        package: 'typo3/cms-t3editor',
    },
    {
        identifier: 'EasyWeChatComposer\\',
        package: 'easywechat-composer/easywechat-composer',
    },
    {
        identifier: 'Joli\\JoliNotif\\',
        package: 'jolicode/jolinotif',
    },
    {
        identifier: 'Ballen\\Collection\\',
        package: 'ballen/collection',
    },
    {
        identifier: 'Ballen\\Plexity\\',
        package: 'ballen/plexity',
    },
    {
        identifier: 'eXorus\\PhpMimeMailParser\\',
        package: 'php-mime-mail-parser/php-mime-mail-parser',
    },
    {
        identifier: 'Sylius\\Bundle\\ResourceBundle\\',
        package: 'sylius/resource-bundle',
    },
    {
        identifier: 'Payum\\Bundle\\PayumBundle',
        package: 'payum/payum',
    },
    {
        identifier: 'Spatie\\Url\\',
        package: 'spatie/url',
    },
    {
        identifier: 'URLify',
        package: 'jbroadway/urlify',
    },
    {
        identifier: 'Bazinga\\Bundle\\GeocoderBundle',
        package: 'willdurand/geocoder-bundle',
    },
    {
        identifier: 'TYPO3\\CMS\\Adminpanel\\',
        package: 'typo3/cms-adminpanel',
    },
    {
        identifier: 'GeoIO\\WKB\\Parser\\',
        package: 'geo-io/wkb-parser',
    },
    {
        identifier: 'JeroenNoten\\LaravelAdminLte\\',
        package: 'jeroennoten/laravel-adminlte',
    },
    {
        identifier: 'SchemaOrgModel',
        package: 'api-platform/schema-generator',
    },
    {
        identifier: 'Cache\\Adapter\\Filesystem\\',
        package: 'cache/filesystem-adapter',
    },
    {
        identifier: 'MJS\\TopSort\\',
        package: 'marcj/topsort',
    },
    {
        identifier: 'FM\\ElfinderBundle',
        package: 'helios-ag/fm-elfinder-bundle',
    },
    {
        identifier: 'Cache\\Adapter\\Redis\\',
        package: 'cache/redis-adapter',
    },
    {
        identifier: 'CrEOF\\WKT',
        package: 'creof/wkt-parser',
    },
    {
        identifier: 'ZBateson\\MailMimeParser\\',
        package: 'zbateson/mail-mime-parser',
    },
    {
        identifier: 'Amp\\Parallel\\',
        package: 'amphp/parallel',
    },
    {
        identifier: 'Shudrum\\Component\\ArrayFinder\\',
        package: 'shudrum/array-finder',
    },
    {
        identifier: 'kartik\\typeahead\\',
        package: 'kartik-v/yii2-widget-typeahead',
    },
    {
        identifier: 'CrEOF\\WKB',
        package: 'creof/wkb-parser',
    },
    {
        identifier: 'Gitlab\\',
        package: 'm4tthumphrey/php-gitlab-api',
    },
    {
        identifier: 'Matthias\\SymfonyDependencyInjectionTest\\',
        package: 'matthiasnoback/symfony-dependency-injection-test',
    },
    {
        identifier: 'voku\\',
        package: 'voku/stop-words',
    },
    {
        identifier: 'Console',
        package: 'pear/console_commandline',
    },
    {
        identifier: 'Propel',
        package: 'propel/propel',
    },
    {
        identifier: 'PHPStan\\',
        package: 'phpstan/phpstan-mockery',
    },
    {
        identifier: 'Zend_Exception',
        package: 'zf1/zend-exception',
    },
    {
        identifier: 'rvtraveller\\QuicksilverComposerInstaller\\',
        package: 'rvtraveller/qs-composer-installer',
    },
    {
        identifier: 'Zend\\Mvc\\I18n\\',
        package: 'zendframework/zend-mvc-i18n',
    },
    {
        identifier: 'rmrevin\\yii\\fontawesome\\',
        package: 'rmrevin/yii2-fontawesome',
    },
    {
        identifier: 'FacebookAds\\',
        package: 'facebook/php-ads-sdk',
    },
    {
        identifier: 'TQ\\Git',
        package: 'teqneers/php-stream-wrapper-for-git',
    },
    {
        identifier: 'CrEOF\\Spatial',
        package: 'creof/doctrine2-spatial',
    },
    {
        identifier: 'TYPO3\\CMS\\Impexp\\',
        package: 'typo3/cms-impexp',
    },
    {
        identifier: 'Cache\\Taggable\\',
        package: 'cache/taggable-cache',
    },
    {
        identifier: 'Hip\\MandrillBundle',
        package: 'slot/mandrill-bundle',
    },
    {
        identifier: 'drupol\\phposinfo\\',
        package: 'drupol/phposinfo',
    },
    {
        identifier: 'Liip\\Monitor',
        package: 'liip/monitor',
    },
    {
        identifier: 'Sonata\\MediaBundle',
        package: 'sonata-project/media-bundle',
    },
    {
        identifier: 'JiraRestApi\\',
        package: 'lesstif/php-jira-rest-client',
    },
    {
        identifier: 'Geotools',
        package: 'league/geotools',
    },
]
